<template>
    <div class="filter-container">
        <el-select :disabled="loading" v-model="query.products" clearable filterable multiple @change="reload"
                   collapse-tags collapse-tags-tooltip style="width: 200px" placeholder="产品">
          <el-option v-for="c in getProductList()" :value="c.key" :label="c.name"></el-option>
        </el-select>
        <el-select v-model="query.category_ids" clearable filterable multiple placeholder="分类" @change="reload"
                   collapse-tags collapse-tags-tooltip style="width: 200px">
            <el-option v-for="c in category_list" :label="c.i18n_name.ZH_HANS" :value="c.id"></el-option>
        </el-select>
        <el-cascader v-model="query.major_tags" placeholder="主要标签" clearable filterable :options="major_list"
                     :props="multiSelectProps" @change="reload" collapse-tags collapse-tags-tooltip style="width: 270px"></el-cascader>
        <el-cascader v-model="query.minor_tags" placeholder="次要标签" clearable filterable :options="minor_list"
                     :props="multiSelectProps" @change="reload" collapse-tags collapse-tags-tooltip style="width: 270px"></el-cascader>
        <el-cascader v-model="query.assistant_tags" placeholder="辅助标签" clearable filterable :options="assistant_list"
                     :props="multiSelectProps" @change="reload" collapse-tags collapse-tags-tooltip style="width: 270px"></el-cascader>
        <el-select v-model="query.status" placeholder="审核状态" clearable @change="reload" style="width: 100px">
            <el-option label="审核通过" value="AUDITED"></el-option>
            <el-option label="审核中" value="AUDITING"></el-option>
            <el-option label="审核不通过" value="REJECTED"></el-option>
        </el-select>
        <el-select v-model="query.test_state" placeholder="测试标记" clearable @change="reload" style="width: 120px">
            <el-option label="全部测试图" value="test"></el-option>
            <el-option label="待上线" value="waiting"></el-option>
            <el-option label="测试中" value="running"></el-option>
            <el-option label="已结束测试" value="finished"></el-option>
            <el-option label="普通图片" value="normal"></el-option>
        </el-select>
        <el-input v-model="query.test_direction" clearable placeholder="测试方向" @change="reload" style="width: 150px"></el-input>
        <el-select v-if="!isClassicProduct()" v-model="query.video" placeholder="激励视频" clearable @change="reload" style="width: 100px">
          <el-option label="是" :value="true"></el-option>
          <el-option label="否" :value="false"></el-option>
        </el-select>
        <el-select v-if="!isClassicProduct()" v-model="query.is_animated" placeholder="是否动图" clearable @change="reload" style="width: 100px">
          <el-option label="是" :value="true"></el-option>
          <el-option label="否" :value="false"></el-option>
        </el-select>
        <el-select v-model="query.unauthorized" placeholder="版权状态" clearable @change="reload" style="width: 100px">
            <el-option label="无版权" :value="true"></el-option>
            <el-option label="有版权" :value="false"></el-option>
        </el-select>
        <el-select v-model="query.online" placeholder="图片上线状态" clearable @change="reload" style="width: 130px">
            <el-option label="已上线" :value="true"></el-option>
            <el-option label="未上线或待上线" :value="false"></el-option>
        </el-select>
        <el-select v-model="query.collection_usage" placeholder="合集使用状态" clearable @change="reload" style="width: 180px">
            <el-option label="仅未被使用（可删除）" value="deletable"></el-option>
            <el-option label="未加入合集" value="unassigned"></el-option>
            <el-option label="任意合集占用" value="assigned"></el-option>
            <el-option label="线上合集使用" value="online"></el-option>
            <el-option label="待上线/停用合集占用" value="offline"></el-option>
        </el-select>
        <el-select v-model="query.source" placeholder="来源" clearable @change="reload" style="width: 150px">
            <el-option v-for="s in source_list" :value="s"></el-option>
        </el-select>
        <el-select v-model="query.module" placeholder="模块" clearable @change="reload" style="width: 100px">
            <el-option label="图库" value="LIBRARY"></el-option>
            <el-option label="集合" value="COLLECTION"></el-option>
            <el-option label="每日" value="DAILY"></el-option>
            <el-option label="运营活动" value="EVENT"></el-option>
        </el-select>
        <el-input v-model="query.id" placeholder="ID" @change="reload" style="width: 220px"></el-input>
        <date-range-picker v-model="query" end-placeholder="上线时间结束" start-placeholder="上线时间开始" style="width: 200px"
                           @change="reload" clearable :disabled-date="function() {}"></date-range-picker>
        <el-button :disabled="loading" :type="editButton.type" @click="openEdit()">{{editButton.text}}</el-button>
        <el-button :disabled="loading" type="primary" @click="openDialog()">上传</el-button>
        <el-button :disabled="loading || batchLoading" type="primary" @click="openBatchDialog()">批量上传</el-button>
        <el-button :disabled="loading || this.idList.length === 0" type="primary" @click="openBatchTagDialog()">批量操作</el-button>
        <el-button :disabled="loading" type="primary" @click="openConditionEditDialog()">条件编辑</el-button>
        <el-button v-if="canDeleteGallery" :disabled="loading" type="danger" @click="batchDelete()">批量删除</el-button>
        <el-button :disabled="loading || dimensionRepair.running" type="warning" plain @click="openDimensionRepairDialog">图片尺寸检查</el-button>
    </div>
    <div v-if="this.idList.length > 0" style="margin-top: 10px; margin-bottom: 10px; display: flex; align-items: center;">
        <span style="margin-right: 20px;">当前选中：{{ this.idList.length }} 项</span>
        <el-button type="success" :loading="loading" @click="batchAuditSelected">批量通过</el-button>
        <el-button type="warning" :loading="loading" @click="openBatchTestDialog">标记测试方向</el-button>
        <el-button type="primary" :loading="downloadingImages" @click="downloadSelectedImages">下载原图</el-button>
        <el-button type="default" @click="clearAllSelection">取消所有多选</el-button>
    </div>
    <div v-if="batchProgress.visible && !dialogBatch_opened" style="margin-top: 10px; width: 520px;">
        <el-progress :percentage="batchProgress.percent" :status="batchProgress.status"></el-progress>
        <div style="font-size: 12px; color: #606266; margin-top: 4px;">{{ batchProgress.text }}</div>
        <div style="margin-top: 6px;">
            <el-button v-if="isBatchJobCancellable()" size="small" type="warning" plain @click="cancelBatchImageJob">取消任务</el-button>
            <el-button v-else-if="batchProgress.status === 'exception'" size="small" type="primary" plain @click="restartBatchUpload">重新上传</el-button>
        </div>
    </div>
    <div v-if="dimensionRepair.job && !dimensionRepairDialog" style="margin-top: 10px; width: 520px;">
        <el-progress :percentage="dimensionRepair.percent" :status="dimensionRepair.progressStatus"></el-progress>
        <div style="font-size: 12px; color: #606266; margin-top: 4px;">{{ dimensionRepair.text }}</div>
    </div>
    <el-table ref="table" style="margin-top: 15px;" v-loading="loading" :data="data" :row-key="rowKey" @selection-change="handleSelectionChange">
         <el-table-column
            type="selection"
            width="55"
            :reserve-selection="true">
        </el-table-column>
        <el-table-column label="序号" width="80">
          <template #default="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="ID" prop="id" width="130"></el-table-column>
        <el-table-column label="状态" prop="status" width="100">
            <template #default="scope">
                <el-select :disabled="scope.row._saving || sharedProductKeys(scope.row).length > 1"
                           title="历史共享图片请通过编辑弹窗确认后修改" style="width: 80px" v-model="scope.row.status"
                           @change="update(scope.row)">
                    <el-option label="通过" value="AUDITED"></el-option>
                    <el-option label="审核中" value="AUDITING"></el-option>
                    <el-option label="不通过" value="REJECTED"></el-option>
                </el-select>
            </template>
        </el-table-column>
        <el-table-column label="图片" prop="resource" width="200">
            <template #default="scope">
                <el-image lazy :src="resourceUrl(scope.row.thumbnail)" style="width: 180px"/>
                <div style="text-align: center;">
                    <a :href="resourceUrl(scope.row.resource)" target="_blank">高清大图</a>
                </div>
            </template>
        </el-table-column>
        <el-table-column label="测试方向" width="170">
            <template #default="scope">
                <template v-if="scope.row.test_info && scope.row.test_info.direction">
                    <el-tag :type="scope.row.test_info.status === 'FINISHED' ? 'info' : (scope.row.test_info.status === 'WAITING' ? '' : 'warning')" size="small">
                        {{ {WAITING: '待上线', RUNNING: '测试中', FINISHED: '已结束'}[scope.row.test_info.status] || '待上线' }} · {{ scope.row.test_info.direction }}
                    </el-tag>
                    <div style="font-size: 12px; color: #909399; margin-top: 4px; word-break: break-all;">
                        {{ scope.row.test_info.batch }}
                    </div>
                </template>
                <span v-else style="color: #c0c4cc;">普通图片</span>
            </template>
        </el-table-column>
        <el-table-column label="动图" prop="animation" width="200">
            <template #default="scope">
                <video v-if="scope.row.animation" :src="resourceUrl(scope.row.animation)" controls muted playsinline style="width: 180px; aspect-ratio: 1 / 1; object-fit: cover"></video>
                <span v-else style="color: #999;">静图</span>
                <div v-if="scope.row.missing_assets && scope.row.missing_assets.length" style="margin-top: 4px;">
                    <el-tag type="danger" size="small">{{ assetIssueText(scope.row.missing_assets) }}</el-tag>
                </div>
            </template>
        </el-table-column>
        <el-table-column label="价格" prop="cost" width="100">
            <template #default="scope">
                <el-select :disabled="scope.row._saving || isPriceEditLocked(scope.row)"
                           :title="priceEditHint(scope.row)" v-model="scope.row.cost" style="width: 80px"
                           @change="changeCost(scope.row)">
                    <el-option :value="0"></el-option>
                    <el-option :value="20"></el-option>
                </el-select>
            </template>
        </el-table-column>
        <el-table-column label="来源" prop="source" width="100"></el-table-column>
        <el-table-column label="上线时间" prop="online_date" width="140">
            <template #default="scope">
                <el-date-picker style="width: 120px" value-format="YYYY-MM-DD" v-model="scope.row.online_date"
                                @change="updateOnlineDate(scope.row)" :clearable="false"
                                :disabled="scope.row._saving"></el-date-picker>
            </template>
        </el-table-column>
        <el-table-column label="使用状态" width="230">
            <template #default="scope">
                <el-tag v-if="scope.row.achievement_reward" type="danger" size="small"
                        style="display: block; width: fit-content; margin: 2px 0;">
                    成就奖励（不可进日更）
                </el-tag>
                <template v-if="scope.row.collection_refs && scope.row.collection_refs.length">
                    <el-tag v-for="ref in scope.row.collection_refs" :key="`${ref.type}-${ref.id}`"
                            :type="ref.state === 'online' ? 'danger' : 'warning'" size="small"
                            style="display: block; width: fit-content; margin: 2px 0;">
                        {{ collectionReferenceText(ref) }}
                    </el-tag>
                </template>
                <el-tag v-else type="success" size="small">未加入合集</el-tag>
            </template>
        </el-table-column>
        <el-table-column label="平台" prop="platform" width="80">
          <template #default="scope">
            <el-tag v-if="scope.row.platform">{{scope.row.platform}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="模块" prop="modules" width="150">
            <template #default="scope">
                <div v-if="scope.row.modules">
                    <el-tag v-for="(module, product) in scope.row.modules" :key="product" size="small" style="margin: 2px;">
                        {{ getProductName(product) }}: {{ {LIBRARY: '图库', COLLECTION: '集合', DAILY: '每日', EVENT: '活动'}[module] }}
                    </el-tag>
                </div>
                <span v-else style="color: #999;">未设置</span>
            </template>
        </el-table-column>
        <el-table-column label="产品" prop="product" width="150">
          <template #default="scope">
            <template v-for="key in scope.row.product">
              <template v-for="c in getProductList()">
                <el-tag v-if="c.key === key">{{ c.name}}</el-tag>
              </template>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="分类" prop="categories" width="80">
            <template #default="scope">
                <el-tag v-for="c in scope.row.categories">{{ category_map[c] }}</el-tag>
            </template>
        </el-table-column>
        <el-table-column label="主要标签" prop="major_tags" width="100">
            <template #default="scope">
                <el-tag v-for="t in scope.row.major_tags">{{ major_map[t] }}</el-tag>
            </template>
        </el-table-column>
        <el-table-column label="次要标签" prop="minor_tags" width="100">
            <template #default="scope">
                <el-tag v-for="t in scope.row.minor_tags">{{ minor_map[t] }}</el-tag>
            </template>
        </el-table-column>
        <el-table-column label="辅助标签" prop="assistant_tags" width="100">
            <template #default="scope">
                <el-tag v-for="t in scope.row.assistant_tags">{{ assistant_map[t] }}</el-tag>
            </template>
        </el-table-column>
        <el-table-column label="版权状态" width="200">
          <template #default="scope">
            <el-tag v-if="scope.row.unauthorized && !edit_unauthorized" type="danger">无版权</el-tag>
            <el-checkbox v-if="edit_unauthorized" v-model="scope.row.unauthorized"
                         :disabled="loading || sharedProductKeys(scope.row).length > 1"
                         title="历史共享图片请通过编辑弹窗确认后修改"
                         @change="updateUnauthorized(scope.row)">无版权</el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
            <template #default="scope">
                <el-button :disabled="loading" size="small" @click="openDialog(scope.row)">编辑</el-button>
                <el-button v-if="canDeleteGallery" :disabled="loading || !isImageDeletable(scope.row)" size="small" type="danger"
                           :title="deleteProtectionText(scope.row)" @click="remove(scope.row)">删除</el-button>
            </template>
        </el-table-column>
    </el-table>
    <div style="display: flex; justify-content: space-between">
        <el-pagination layout="prev, pager, next" :total="total" :page-size="this.query.limit"
                       @current-change="pageChange" :disabled="loading"></el-pagination>
        <el-select v-model="query.limit" style="width: 100px" @change="reload" :disabled="loading">
            <el-option :value="20"></el-option>
            <el-option :value="50"></el-option>
            <el-option :value="100"></el-option>
        </el-select>
    </div>
    <el-dialog v-model="dialog_opened" :before-close="reset">
        <el-form ref="form" label-width="100px" :model="form">
            <el-alert
                v-if="editing && sharedProductKeys(editing).length > 1"
                :title="`这是一张跨产品共享的历史图片，同时用于：${sharedProductNames(editing).join('、')}。修改图片、标签、分类或状态会同步影响这些产品。`"
                type="warning"
                :closable="false"
                show-icon
                style="margin-bottom: 16px" />
            <el-form-item label="选择图片" prop="resource" :rules="[{required: true, message: '请选择图片'}]">
                <el-upload action="/cms/v1/resource" :show-file-list="false" :onSuccess="handleSuccess"
                           accept="image/*" :data="{prefix: 'images'}" :onProgress="handleProgress"
                           :before-upload="beforeUpload">
                    <img v-if="form.resource" :src="resourceUrl(form.resource)"
                         style="width: 200px">
                    <el-button size="small" v-else :loading="loading">上传</el-button>
                </el-upload>
            </el-form-item>
            <el-form-item v-if="!isClassicProduct()" label="完成动图" prop="animation">
                <el-upload action="/cms/v1/resource" :show-file-list="false" :onSuccess="handleAnimationSuccess"
                           accept="video/mp4,.mp4" :data="{prefix: 'animations'}" :onProgress="handleProgress"
                           :before-upload="beforeAnimationUpload">
                    <video v-if="form.animation" :src="resourceUrl(form.animation)" controls muted playsinline style="width: 200px"></video>
                    <el-button size="small" v-else :loading="loading">上传 MP4</el-button>
                </el-upload>
                <el-button v-if="form.animation" type="danger" size="small" text @click="form.animation = ''">清除动图</el-button>
            </el-form-item>
            <el-form-item label="平台" prop="platform">
              <el-select v-model="form.platform" filterable placeholder="请选择平台" :disabled="loading" style="width: 140px">
                <el-option v-for="c in [null, 'android', 'ios']" :value="c" :label="c === null ? 'all' : c"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="分类" prop="categories" :rules="[{required: true, message: '请选择分类'}]">
                <el-select v-model="form.categories" multiple filterable :disabled="loading" style="width: 100%">
                    <el-option v-for="c in category_list" :value="c.id" :label="c.i18n_name.ZH_HANS"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="主要标签" prop="major_tags">
                <el-tag v-for="t in form.major_tags" closable @close="removeTag('major_tags', t)">{{
                        major_map[t]
                    }}
                </el-tag>
                <el-popover trigger="click" v-if="form.major_tags.length < 1">
                    <el-cascader size="mini" :options="major_list" filterable :props="props"
                                 @change="addTag($event, 'major_tags')"></el-cascader>
                    <template #reference>
                        <el-button size="mini" type="text">添加
                        </el-button>
                    </template>
                </el-popover>
            </el-form-item>
            <el-form-item label="次要标签" prop="minor_tags">
                <el-tag v-for="t in form.minor_tags" closable @close="removeTag('minor_tags', t)">{{
                        minor_map[t]
                    }}
                </el-tag>
                <el-popover trigger="click">
                    <el-cascader size="mini" :options="minor_list" filterable :props="props"
                                 @change="addTag($event, 'minor_tags')"></el-cascader>
                    <template #reference>
                        <el-button size="mini" type="text">添加
                        </el-button>
                    </template>
                </el-popover>
            </el-form-item>
            <el-form-item label="辅助标签" prop="assistant_tags">
                <el-tag v-for="t in form.assistant_tags" closable @close="removeTag('assistant_tags', t)">
                    {{ assistant_map[t] }}
                </el-tag>
                <el-popover trigger="click">
                    <el-cascader size="mini" :options="assistant_list" filterable :props="props"
                                 @change="addTag($event, 'assistant_tags')"></el-cascader>
                    <template #reference>
                        <el-button size="mini" type="text">添加
                        </el-button>
                    </template>
                </el-popover>
            </el-form-item>
            <test-plan-picker v-model="form.test_info" :categories="form.categories"
                              :category-map="category_map" :disabled="loading" />
            <el-form-item label="来源" prop="source">
                <el-select v-model="form.source" filterable allow-create :disabled="loading">
                    <el-option v-for="s in source_list" :value="s"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属产品" prop="product" :rules="[{required: true, message: '请选择产品'}]">
              <el-select v-model="form.product" filterable multiple :disabled="loading" style="width: 100%">
                <el-option v-for="c in getProductList()" :value="c.key" :label="c.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="模块" :required="form.product && form.product.length > 0">
                <div v-for="product in form.product" :key="product" style="margin-bottom: 10px; width: 100%;">
                    <el-form-item
                        :prop="`modules.${product}`"
                        :rules="[{required: true, message: `请为 ${getProductName(product)} 选择模块`, trigger: ['change', 'blur']}]"
                        style="margin-bottom: 0;"
                    >
                        <label style="width: 120px; display: inline-block; font-weight: bold;">
                            {{ getProductName(product) }}:
                        </label>
                        <el-select v-model="form.modules[product]" :disabled="loading" style="width: 200px;"
                                   placeholder="请选择模块" clearable>
                            <el-option label="图库" value="LIBRARY"></el-option>
                            <el-option label="Daily" value="DAILY"></el-option>
                            <el-option label="集合" value="COLLECTION"></el-option>
                            <el-option label="活动" value="EVENT"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div v-if="!form.product || form.product.length === 0" style="color: #999;">
                    请先选择产品
                </div>
            </el-form-item>
            <el-form-item label="价格" prop="cost">
                <el-select v-model="form.cost" :disabled="loading || isClassicProduct()">
                    <el-option :value="0"></el-option>
                    <el-option :value="20"></el-option>
                </el-select>
            </el-form-item>
<!--            <el-form-item label="活动标签" prop="activity">-->
<!--                <el-radio-group v-model="form.activity" :disabled="loading">-->
<!--                    <el-radio :label="null">无</el-radio>-->
<!--                    <el-radio :label="2">复活节</el-radio>-->
<!--                </el-radio-group>-->
<!--            </el-form-item>-->
            <el-form-item label="版权" prop="unauthorized">
                <el-checkbox v-model="form.unauthorized" :disabled="loading">无版权</el-checkbox>
            </el-form-item>
            <el-form-item label="包含国家" prop="include_country">
                <el-select v-model="form.include_country" filterable multiple :disabled="loading" style="width: 100%">
                    <el-option v-for="c in $root.country_list" :value="c.code"
                               :label="c.en_name + ' (' + c.code + ')'"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="排除国家" prop="exclude_country">
                <el-select v-model="form.exclude_country" filterable multiple :disabled="loading" style="width: 100%">
                    <el-option v-for="c in $root.country_list" :value="c.code"
                               :label="c.en_name + ' (' + c.code + ')'"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button type="primary" :loading="loading" text @click="reset">取消</el-button>
            <el-button type="primary" :loading="loading" @click="submit">确定</el-button>
        </template>
    </el-dialog>
        <el-dialog v-model="dialogBatch_opened" :before-close="beforeCloseBatchDialog">
        <el-form ref="batchForm" label-width="100px" :model="batchForm">
             <el-form-item label="上传压缩包" prop="file">
                <el-upload
                    class="upload-demo"
                    action="#"
                    drag
                    :auto-upload="false"
                    :limit="1"
                    :on-change="handleBatchFileChange"
                    :on-remove="handleRemove"
                    :before-upload="batchBeforeUpload"
                    :file-list="fileList"
                    :on-exceed="handleExceed"
                    accept=".zip"
                    >
                    <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
                    <div slot="tip" class="el-upload__tip">支持 zip 压缩包，包内图片支持 jpg/jpeg/png/webp，动图支持 mp4；单独 mp4 会按文件名匹配已有图片 ID</div>
                </el-upload>
            </el-form-item>
            <el-form-item v-if="batchProgress.visible" label="进度">
                <div style="width: 100%;">
                    <el-progress :percentage="batchProgress.percent" :status="batchProgress.status"></el-progress>
                    <div style="font-size: 12px; color: #606266; margin-top: 6px;">
                        {{ batchProgress.text }}
                    </div>
                    <div style="margin-top: 6px;">
                        <el-button v-if="batchProgress.clientPaused" size="small" type="primary" plain @click="retryPausedBatchImageJob">继续重试</el-button>
                        <el-button v-if="isBatchJobCancellable()" size="small" type="warning" plain @click="cancelBatchImageJob">取消任务</el-button>
                    </div>
                    <div v-if="batchProgress.errors && batchProgress.errors.length" style="font-size: 12px; color: #f56c6c; margin-top: 6px;">
                        <div v-for="err in batchProgress.errors.slice(0, 3)" :key="err.filename">
                            {{ err.filename }}：{{ err.error_message }}
                        </div>
                    </div>
                    <div v-if="batchProgress.diagnostics && batchProgress.diagnostics.length" style="margin-top: 10px; border-top: 1px solid #ebeef5; padding-top: 8px; font-size: 12px; color: #606266; max-height: 180px; overflow-y: auto;">
                        <div style="font-weight: 600; margin-bottom: 4px;">处理诊断（测试）</div>
                        <div v-for="(event, index) in batchProgress.diagnostics" :key="`${event.at}-${index}`" style="line-height: 20px; word-break: break-all;">
                            +{{ formatBatchDiagnosticElapsed(event.elapsed_ms) }} {{ event.message }}
                        </div>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="分类" prop="categories" >
                <el-select v-model="batchForm.categories" multiple filterable :disabled="batchLoading" style="width: 100%">
                    <el-option v-for="c in category_list" :value="c.id" :label="c.i18n_name.ZH_HANS"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="模块" prop="module">
                <el-radio-group v-model="batchForm.module" :disabled="batchLoading">
                    <el-radio label="LIBRARY">图库</el-radio>
                    <el-radio label="DAILY">Daily</el-radio>
                    <el-radio label="COLLECTION">集合</el-radio>
                    <el-radio label="EVENT">活动</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="所属产品" prop="product" :rules="[{required: true, message: '请选择产品'}]">
                <span>{{ getProduct().name }}</span>
                <div class="el-form-item__tip">批量上传只写入当前产品。</div>
            </el-form-item>
            <el-form-item label="AI 打标签" prop="needs_ai_tag">
                <el-checkbox v-model="batchForm.needs_ai_tag" :disabled="batchLoading">
                    导入后纳入一键 AI 打标签
                </el-checkbox>
            </el-form-item>
            <test-plan-picker v-model="batchForm.test_info" :categories="batchForm.categories"
                              :category-map="category_map" :disabled="batchLoading" />
            <el-form-item label="处理方式" prop="client_preprocess">
                <el-checkbox v-model="batchForm.client_preprocess" :disabled="batchLoading">
                    使用本机处理静态图（推荐）
                </el-checkbox>
                <div class="el-form-item__tip">逐张解压并转换后上传，降低服务器压力；特殊动图配对会自动切换到兼容流程。</div>
            </el-form-item>
            <el-form-item label="图片尺寸" prop="force_resize">
                <el-checkbox v-model="batchForm.force_resize" :disabled="batchLoading">
                    非 2048×2048 图片强制转换为 2048×2048 WebP
                </el-checkbox>
                <div class="el-form-item__tip">将等比缩放并居中裁切，未勾选时尺寸不符的图片会导入失败。</div>
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button type="primary" :disabled="batchLoading" :loading="loading" text @click="batchReset">取消</el-button>
            <el-button type="primary" :loading="batchLoading" @click="batchSubmit">确定</el-button>
        </template>
    </el-dialog>
    <el-dialog v-model="dimensionRepairDialog" title="图片尺寸检查与修复" width="560px" :close-on-click-modal="!dimensionRepair.running">
        <el-alert type="warning" :closable="false" show-icon style="margin-bottom: 16px;"
                  title="扫描当前产品和时间范围内的图片。所有拼图产品统一使用 2048×2048；共享资源会同步修复所有引用。修复前自动备份原文件。"></el-alert>
        <el-form label-width="110px">
            <el-form-item label="当前产品">
                <span>{{ getProduct().name }}</span>
            </el-form-item>
            <el-form-item label="导入时间范围">
                <date-range-picker v-model="dimensionRepair.form" :disabled="dimensionRepair.running || !!dimensionRepair.job"
                                   start-placeholder="开始日期" end-placeholder="结束日期" style="width: 350px"></date-range-picker>
            </el-form-item>
            <el-form-item label="修复规则">
                <el-input-number v-model="dimensionRepair.form.source_width" :min="1" :max="10000"
                                 :disabled="dimensionRepair.running || !!dimensionRepair.job" style="width: 120px"></el-input-number>
                <span style="margin: 0 8px;">×</span>
                <el-input-number v-model="dimensionRepair.form.source_height" :min="1" :max="10000"
                                 :disabled="dimensionRepair.running || !!dimensionRepair.job" style="width: 120px"></el-input-number>
                <span style="margin-left: 8px;">→ 2048×2048</span>
            </el-form-item>
            <el-form-item v-if="dimensionRepair.job" label="任务进度">
                <div style="width: 100%;">
                    <el-progress :percentage="dimensionRepair.percent" :status="dimensionRepair.progressStatus"></el-progress>
                    <div style="font-size: 12px; color: #606266; margin-top: 6px;">{{ dimensionRepair.text }}</div>
                    <div v-if="dimensionRepair.job.samples && dimensionRepair.job.samples.length" style="font-size: 12px; margin-top: 6px;">
                        样例：{{ dimensionRepair.job.samples.slice(0, 3).map(item => item.resource).join('、') }}
                    </div>
                    <div v-if="dimensionRepair.job.impact_count" style="font-size: 12px; margin-top: 6px;">
                        共享资源影响 {{ dimensionRepair.job.impact_count }} 条图片记录：{{ formatDimensionRepairImpact(dimensionRepair.job.impacted_products) }}
                    </div>
                    <div v-if="dimensionRepair.job.errors && dimensionRepair.job.errors.length" style="font-size: 12px; color: #f56c6c; margin-top: 6px;">
                        {{ dimensionRepair.job.errors.slice(0, 3).map(item => `${item.resource}：${item.error_message}`).join('；') }}
                    </div>
                </div>
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button text @click="dimensionRepairDialog = false">关闭</el-button>
            <el-button v-if="!dimensionRepair.job" type="primary" :loading="dimensionRepair.running" @click="startDimensionRepairScan">开始扫描</el-button>
            <template v-else-if="dimensionRepair.job.status === 'scan_finished'">
                <el-button :disabled="dimensionRepair.running" @click="resetDimensionRepair">重新扫描</el-button>
                <el-button type="danger" :loading="dimensionRepair.running"
                           :disabled="!dimensionRepair.job.candidate_count" @click="confirmDimensionRepair">
                    备份并修复 {{ dimensionRepair.job.candidate_count }} 张
                </el-button>
            </template>
            <el-button v-else-if="!dimensionRepair.running" type="primary" @click="resetDimensionRepair">重新扫描</el-button>
        </template>
    </el-dialog>
    <el-dialog v-model="batchTagDialog" :before-close="batchTagReset" title="批量操作">
        <el-form ref="batchTagForm" label-width="100px" :model="batchTagForm">
            <el-form-item label="操作模式">
                <el-radio-group v-model="tagMode">
                    <el-radio label="add">追加模式</el-radio>
                    <el-radio label="delete">删除模式</el-radio>
                </el-radio-group>
            </el-form-item>
            <!-- 分类操作 -->
            <el-form-item label="分类" prop="categories">
                <template v-if="tagMode === 'add'">
                    <el-select v-model="batchTagForm.categories" multiple filterable style="width: 100%">
                        <el-option v-for="c in category_list" :value="c.id" :label="c.i18n_name.ZH_HANS"></el-option>
                    </el-select>
                </template>
                <template v-else>
                    <div style="padding: 10px; background-color: #f5f7fa; border-radius: 4px;">
                        <div style="margin-bottom: 8px;">
                            <span style="color: #606266; font-size: 14px; font-weight: 500;">共同分类（选择要删除的分类）：</span>
                        </div>
                        <el-checkbox-group v-model="batchTagForm.categories" style="display: flex; flex-wrap: wrap;">
                            <div v-for="cat in commonTags.categories" :key="cat" style="margin: 5px;">
                                <el-checkbox :label="cat" style="margin-right: 5px;">
                                    <el-tag 
                                        :type="batchTagForm.categories.includes(cat) ? 'success' : 'info'"
                                        size="medium"
                                        style="cursor: pointer; padding: 2px 8px;">
                                        {{ category_map[cat] }}
                                    </el-tag>
                                </el-checkbox>
                            </div>
                        </el-checkbox-group>
                        <div v-if="commonTags.categories.length === 0" style="color: #909399; font-size: 14px; margin-top: 5px;">无共同分类</div>
                    </div>
                </template>
            </el-form-item>
            <!-- 所属产品操作 -->
            <el-form-item label="所属产品" prop="product">
                <template v-if="tagMode === 'add'">
                    <el-select v-model="batchTagForm.product" filterable multiple style="width: 100%">
                        <el-option v-for="c in getProductList()" :value="c.key" :label="c.name"></el-option>
                    </el-select>
                </template>
                <template v-else>
                    <div style="padding: 10px; background-color: #f5f7fa; border-radius: 4px;">
                        <div style="margin-bottom: 8px;">
                            <span style="color: #606266; font-size: 14px; font-weight: 500;">共同产品（选择要删除的产品）：</span>
                        </div>
                        <el-checkbox-group v-model="batchTagForm.product" style="display: flex; flex-wrap: wrap;">
                            <div v-for="prod in commonTags.product" :key="prod" style="margin: 5px;">
                                <el-checkbox :label="prod" style="margin-right: 5px;">
                                    <el-tag 
                                        :type="batchTagForm.product.includes(prod) ? 'success' : 'info'"
                                        size="medium"
                                        style="cursor: pointer; padding: 2px 8px;">
                                        {{ getProductName(prod) }}
                                    </el-tag>
                                </el-checkbox>
                            </div>
                        </el-checkbox-group>
                        <div v-if="commonTags.product.length === 0" style="color: #909399; font-size: 14px; margin-top: 5px;">无共同产品</div>
                    </div>
                </template>
            </el-form-item>
            <!-- 批量模式不支持主要标签，已隐藏 -->
            <el-form-item label="次要标签" prop="minor_tags">
                <template v-if="tagMode === 'add'">
                    <div style="display: flex; align-items: center; flex-wrap: wrap;">
                        <div style="display: flex; flex-wrap: wrap; align-items: center; margin-right: 10px;">
                            <el-tag
                                v-for="tag in batchTagForm.minor_tags"
                                :key="tag"
                                closable
                                @close="removeBatchTag('minor_tags', tag)"
                                style="margin-right: 5px; margin-bottom: 5px;">
                                {{ this.minor_map[tag] }}
                            </el-tag>
                        </div>
                        <el-popover trigger="click">
                            <el-cascader size="mini" :options="this.minor_list" filterable :props="this.props"
                                         @change="addBatchTag($event, 'minor_tags')"></el-cascader>
                            <template #reference>
                                <el-button size="mini" type="text">添加
                                </el-button>
                            </template>
                        </el-popover>
                    </div>
                </template>
                <template v-else>
                    <div style="padding: 10px; background-color: #f5f7fa; border-radius: 4px;">
                        <div style="margin-bottom: 8px;">
                            <span style="color: #606266; font-size: 14px; font-weight: 500;">共同标签（选择要删除的标签）：</span>
                        </div>
                        <el-checkbox-group v-model="batchTagForm.minor_tags" style="display: flex; flex-wrap: wrap;">
                            <div v-for="tag in commonTags.minor_tags" :key="tag" style="margin: 5px;">
                                <el-checkbox :label="tag" style="margin-right: 5px;">
                                    <el-tag 
                                        :type="batchTagForm.minor_tags.includes(tag) ? 'success' : 'info'"
                                        size="medium"
                                        style="cursor: pointer; padding: 2px 8px;">
                                        {{ this.minor_map[tag] }}
                                    </el-tag>
                                </el-checkbox>
                            </div>
                        </el-checkbox-group>
                        <div v-if="commonTags.minor_tags.length === 0" style="color: #909399; font-size: 14px; margin-top: 5px;">无共同次要标签</div>
                    </div>
                </template>
            </el-form-item>
            <el-form-item label="辅助标签" prop="assistant_tags">
                <template v-if="tagMode === 'add'">
                    <div style="display: flex; align-items: center; flex-wrap: wrap;">
                        <div style="display: flex; flex-wrap: wrap; align-items: center; margin-right: 10px;">
                            <el-tag
                                v-for="tag in batchTagForm.assistant_tags"
                                :key="tag"
                                closable
                                @close="removeBatchTag('assistant_tags', tag)"
                                style="margin-right: 5px; margin-bottom: 5px;">
                                {{ this.assistant_map[tag] }}
                            </el-tag>
                        </div>
                        <el-popover trigger="click">
                            <el-cascader size="mini" :options="this.assistant_list" filterable :props="this.props"
                                         @change="addBatchTag($event, 'assistant_tags')"></el-cascader>
                            <template #reference>
                                <el-button size="mini" type="text">添加
                                </el-button>
                            </template>
                        </el-popover>
                    </div>
                </template>
                <template v-else>
                    <div style="padding: 10px; background-color: #f5f7fa; border-radius: 4px;">
                        <div style="margin-bottom: 8px;">
                            <span style="color: #606266; font-size: 14px; font-weight: 500;">共同标签（选择要删除的标签）：</span>
                        </div>
                        <el-checkbox-group v-model="batchTagForm.assistant_tags" style="display: flex; flex-wrap: wrap;">
                            <div v-for="tag in commonTags.assistant_tags" :key="tag" style="margin: 5px;">
                                <el-checkbox :label="tag" style="margin-right: 5px;">
                                    <el-tag 
                                        :type="batchTagForm.assistant_tags.includes(tag) ? 'success' : 'info'"
                                        size="medium"
                                        style="cursor: pointer; padding: 2px 8px;">
                                        {{ this.assistant_map[tag] }}
                                    </el-tag>
                                </el-checkbox>
                            </div>
                        </el-checkbox-group>
                        <div v-if="commonTags.assistant_tags.length === 0" style="color: #909399; font-size: 14px; margin-top: 5px;">无共同辅助标签</div>
                    </div>
                </template>
            </el-form-item>
            
            <!-- 模块配置区域（仅追加模式显示） -->
            <el-form-item v-if="tagMode === 'add'" label="修改模块">
                <div v-for="product in getProductList()" :key="product.key" style="margin-bottom: 15px; padding: 10px; border: 1px solid #e4e7ed; border-radius: 4px;">
                    <div style="margin-bottom: 8px;">
                        <label style="font-weight: bold; color: #303133;">
                            {{ product.name }}
                        </label>
                    </div>
                    <el-select v-model="batchTagForm.modules[product.key]" clearable placeholder="请选择模块" style="width: 100%;">
                        <el-option label="图库" value="LIBRARY"></el-option>
                        <el-option label="Daily" value="DAILY"></el-option>
                        <el-option label="集合" value="COLLECTION"></el-option>
                        <el-option label="活动" value="EVENT"></el-option>
                    </el-select>
                </div>
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button type="primary" text @click="batchTagReset">取消</el-button>
            <el-button type="primary" :loading="this.loading" @click="batchTagSubmit">确定</el-button>
        </template>
    </el-dialog>
    <el-dialog v-model="batchTestDialog" title="标记测试方向" width="560px">
        <el-alert type="info" :closable="false" show-icon style="margin-bottom: 16px;"
                  title="所选图片会自动归入同一个本周测试批次；普通榜单仍保留数据，AI 会另外做同分类对照分析。"></el-alert>
        <el-form ref="batchTestForm" label-width="100px" :model="batchTestForm">
            <test-plan-picker v-model="batchTestForm" :categories="batchTestCategories"
                              :category-map="category_map" :disabled="loading" />
        </el-form>
        <template #footer>
            <el-button :disabled="loading" @click="batchTestDialog = false">取消</el-button>
            <el-button type="primary" :loading="loading" @click="submitBatchTest">应用到 {{ idList.length }} 张图片</el-button>
        </template>
    </el-dialog>
    <!-- 条件编辑弹窗 -->
    <el-dialog v-model="conditionEditDialog" :before-close="conditionEditReset" title="条件编辑" width="80%" 
               :close-on-click-modal="false" class="condition-edit-dialog">
        <div class="condition-edit-content">
        <el-form ref="conditionEditForm" label-width="120px" :model="conditionEditForm">
            <!-- 上部：条件回显和编辑 -->
            <el-divider content-position="left">查询条件</el-divider>
            <div style="display: flex; flex-wrap: wrap; gap: 10px; margin-bottom: 20px;">
                <el-select v-model="conditionQuery.products" clearable filterable multiple placeholder="产品" 
                           collapse-tags collapse-tags-tooltip style="width: 200px">
                    <el-option v-for="c in getProductList()" :value="c.key" :label="c.name"></el-option>
                </el-select>
                <el-select v-model="conditionQuery.category_ids" clearable filterable multiple placeholder="分类" 
                           collapse-tags collapse-tags-tooltip style="width: 200px">
                    <el-option v-for="c in category_list" :label="c.i18n_name.ZH_HANS" :value="c.id"></el-option>
                </el-select>
                <el-cascader style="width: 270px" v-model="conditionQuery.major_tags" placeholder="主要标签" clearable filterable 
                             :options="major_list" :props="multiSelectProps" collapse-tags collapse-tags-tooltip></el-cascader>
                <el-cascader style="width: 270px" v-model="conditionQuery.minor_tags" placeholder="次要标签" clearable filterable 
                             :options="minor_list" :props="multiSelectProps" collapse-tags collapse-tags-tooltip></el-cascader>
                <el-cascader style="width: 270px" v-model="conditionQuery.assistant_tags" placeholder="辅助标签" clearable filterable 
                             :options="assistant_list" :props="multiSelectProps" collapse-tags collapse-tags-tooltip></el-cascader>
                <el-select v-model="conditionQuery.status" placeholder="审核状态" clearable style="width: 120px">
                    <el-option label="审核通过" value="AUDITED"></el-option>
                    <el-option label="审核中" value="AUDITING"></el-option>
                    <el-option label="审核不通过" value="REJECTED"></el-option>
                </el-select>
                <el-select v-model="conditionQuery.video" placeholder="激励视频" clearable style="width: 120px">
                    <el-option label="是" :value="true"></el-option>
                    <el-option label="否" :value="false"></el-option>
                </el-select>
                <el-select v-model="conditionQuery.is_animated" placeholder="是否动图" clearable style="width: 120px">
                    <el-option label="是" :value="true"></el-option>
                    <el-option label="否" :value="false"></el-option>
                </el-select>
                <el-select v-model="conditionQuery.unauthorized" placeholder="版权状态" clearable style="width: 120px">
                    <el-option label="无版权" :value="true"></el-option>
                    <el-option label="有版权" :value="false"></el-option>
                </el-select>
                <el-select v-model="conditionQuery.online" placeholder="图片上线状态" clearable style="width: 130px">
                    <el-option label="已上线" :value="true"></el-option>
                    <el-option label="未上线或待上线" :value="false"></el-option>
                </el-select>
                <el-select v-model="conditionQuery.source" placeholder="来源" clearable style="width: 150px">
                    <el-option v-for="s in source_list" :value="s"></el-option>
                </el-select>
                <el-select v-model="conditionQuery.module" placeholder="模块" clearable style="width: 120px">
                    <el-option label="图库" value="LIBRARY"></el-option>
                    <el-option label="集合" value="COLLECTION"></el-option>
                    <el-option label="每日" value="DAILY"></el-option>
                    <el-option label="运营活动" value="EVENT"></el-option>
                </el-select>
                <el-input v-model="conditionQuery.id" placeholder="ID" style="width: 220px"></el-input>
                <date-range-picker v-model="conditionQuery" end-placeholder="上线时间结束" start-placeholder="上线时间开始" 
                                   style="width: 200px" clearable :disabled-date="function() {}"></date-range-picker>
            </div>
            
            <!-- 下部：操作配置 -->
            <el-divider content-position="left">批量操作</el-divider>
            
            <!-- 批量操作：所属产品、分类、包含国家、排除国家 - 同一行显示 -->
            <el-form-item label="所属产品">
                <div style="display: flex; align-items: center; gap: 15px;">
                    <el-select v-model="conditionEditForm.product" filterable multiple style="flex: 1;">
                        <el-option v-for="c in getProductList()" :value="c.key" :label="c.name"></el-option>
                    </el-select>
                    <el-radio-group v-model="conditionEditForm.productMode" size="small">
                        <el-radio label="add">追加</el-radio>
                        <el-radio label="delete">删除</el-radio>
                        <el-radio label="replace">覆盖</el-radio>
                    </el-radio-group>
                </div>
            </el-form-item>
            
            <el-form-item label="分类">
                <div style="display: flex; align-items: center; gap: 15px;">
                    <el-select v-model="conditionEditForm.categories" multiple filterable style="flex: 1;">
                        <el-option v-for="c in category_list" :value="c.id" :label="c.i18n_name.ZH_HANS"></el-option>
                    </el-select>
                    <el-radio-group v-model="conditionEditForm.categoriesMode" size="small">
                        <el-radio label="add">追加</el-radio>
                        <el-radio label="delete">删除</el-radio>
                        <el-radio label="replace">覆盖</el-radio>
                    </el-radio-group>
                </div>
            </el-form-item>
            
            <el-form-item label="包含国家">
                <div style="display: flex; align-items: center; gap: 15px;">
                    <el-select v-model="conditionEditForm.include_country" filterable multiple style="flex: 1;">
                        <el-option v-for="c in $root.country_list" :value="c.code"
                                   :label="c.en_name + ' (' + c.code + ')'"></el-option>
                    </el-select>
                    <el-radio-group v-model="conditionEditForm.includeCountryMode" size="small">
                        <el-radio label="add">追加</el-radio>
                        <el-radio label="delete">删除</el-radio>
                        <el-radio label="replace">覆盖</el-radio>
                    </el-radio-group>
                </div>
            </el-form-item>
            
            <el-form-item label="排除国家">
                <div style="display: flex; align-items: center; gap: 15px;">
                    <el-select v-model="conditionEditForm.exclude_country" filterable multiple style="flex: 1;">
                        <el-option v-for="c in $root.country_list" :value="c.code"
                                   :label="c.en_name + ' (' + c.code + ')'"></el-option>
                    </el-select>
                    <el-radio-group v-model="conditionEditForm.excludeCountryMode" size="small">
                        <el-radio label="add">追加</el-radio>
                        <el-radio label="delete">删除</el-radio>
                        <el-radio label="replace">覆盖</el-radio>
                    </el-radio-group>
                </div>
            </el-form-item>
            
            <!-- 标签操作 - 标签和模式选择在同一行对齐 -->
            <el-form-item label="主要标签">
                <div style="display: flex; align-items: center; gap: 15px;">
                    <div style="display: flex; align-items: center; flex-wrap: wrap; flex: 1; gap: 5px;">
                        <el-tag v-for="tag in conditionEditForm.major_tags" :key="tag" closable
                                @close="removeConditionTag('major_tags', tag)" style="margin: 0;">
                            {{ major_map[tag] }}
                        </el-tag>
                        <el-popover trigger="click" placement="bottom-start">
                            <el-cascader size="mini" :options="major_list" filterable :props="props"
                                         @change="addConditionTag($event, 'major_tags')"></el-cascader>
                            <template #reference>
                                <el-button size="small" type="text" style="padding: 0 5px;">添加</el-button>
                            </template>
                        </el-popover>
                    </div>
                    <el-radio-group v-model="conditionEditForm.majorTagsMode" size="small">
                        <el-radio label="add">追加</el-radio>
                        <el-radio label="delete">删除</el-radio>
                        <el-radio label="replace">覆盖</el-radio>
                    </el-radio-group>
                </div>
            </el-form-item>
            
            <el-form-item label="次要标签">
                <div style="display: flex; align-items: center; gap: 15px;">
                    <div style="display: flex; align-items: center; flex-wrap: wrap; flex: 1; gap: 5px;">
                        <el-tag v-for="tag in conditionEditForm.minor_tags" :key="tag" closable
                                @close="removeConditionTag('minor_tags', tag)" style="margin: 0;">
                            {{ minor_map[tag] }}
                        </el-tag>
                        <el-popover trigger="click" placement="bottom-start">
                            <el-cascader size="mini" :options="minor_list" filterable :props="props"
                                         @change="addConditionTag($event, 'minor_tags')"></el-cascader>
                            <template #reference>
                                <el-button size="small" type="text" style="padding: 0 5px;">添加</el-button>
                            </template>
                        </el-popover>
                    </div>
                    <el-radio-group v-model="conditionEditForm.minorTagsMode" size="small">
                        <el-radio label="add">追加</el-radio>
                        <el-radio label="delete">删除</el-radio>
                        <el-radio label="replace">覆盖</el-radio>
                    </el-radio-group>
                </div>
            </el-form-item>
            
            <el-form-item label="辅助标签">
                <div style="display: flex; align-items: center; gap: 15px;">
                    <div style="display: flex; align-items: center; flex-wrap: wrap; flex: 1; gap: 5px;">
                        <el-tag v-for="tag in conditionEditForm.assistant_tags" :key="tag" closable
                                @close="removeConditionTag('assistant_tags', tag)" style="margin: 0;">
                            {{ assistant_map[tag] }}
                        </el-tag>
                        <el-popover trigger="click" placement="bottom-start">
                            <el-cascader size="mini" :options="assistant_list" filterable :props="props"
                                         @change="addConditionTag($event, 'assistant_tags')"></el-cascader>
                            <template #reference>
                                <el-button size="small" type="text" style="padding: 0 5px;">添加</el-button>
                            </template>
                        </el-popover>
                    </div>
                    <el-radio-group v-model="conditionEditForm.assistantTagsMode" size="small">
                        <el-radio label="add">追加</el-radio>
                        <el-radio label="delete">删除</el-radio>
                        <el-radio label="replace">覆盖</el-radio>
                    </el-radio-group>
                </div>
            </el-form-item>
            
            <!-- 其他操作 -->
            <el-form-item label="修改状态">
                <el-select v-model="conditionEditForm.status" clearable placeholder="请选择状态" style="width: 200px">
                    <el-option label="审核通过" value="AUDITED"></el-option>
                    <el-option label="审核中" value="AUDITING"></el-option>
                    <el-option label="审核不通过" value="REJECTED"></el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item v-if="!isClassicProduct()" label="编辑价格">
                <el-select v-model="conditionEditForm.cost" clearable placeholder="请选择价格" style="width: 200px">
                    <el-option :value="0" label="0"></el-option>
                    <el-option :value="20" label="20"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="编辑平台">
                <el-select v-model="conditionEditForm.platform" filterable clearable placeholder="请选择平台" style="width: 200px">
                    <el-option :value="null" label="all"></el-option>
                    <el-option value="android" label="android"></el-option>
                    <el-option value="ios" label="ios"></el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item label="编辑来源">
                <el-select v-model="conditionEditForm.source" filterable allow-create clearable placeholder="请选择或输入来源" style="width: 200px">
                    <el-option v-for="s in source_list" :value="s"></el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item label="修改模块">
                <div v-for="product in getProductList()" :key="product.key" style="margin-bottom: 15px; padding: 10px; border: 1px solid #e4e7ed; border-radius: 4px;">
                    <div style="margin-bottom: 8px;">
                        <label style="font-weight: bold; color: #303133;">
                            {{ product.name }}
                        </label>
                    </div>
                    <el-select v-model="conditionEditForm.modules[product.key]" clearable placeholder="请选择模块" style="width: 100%;">
                        <el-option label="图库" value="LIBRARY"></el-option>
                        <el-option label="Daily" value="DAILY"></el-option>
                        <el-option label="集合" value="COLLECTION"></el-option>
                        <el-option label="活动" value="EVENT"></el-option>
                    </el-select>
                </div>
            </el-form-item>
            
            
            <el-form-item label="编辑版权">
                <el-select v-model="conditionEditForm.unauthorized" clearable placeholder="请选择版权状态" style="width: 200px">
                    <el-option label="无版权" :value="true"></el-option>
                    <el-option label="有版权" :value="false"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        </div>
        <template #footer>
            <el-button type="primary" text @click="conditionEditReset">取消</el-button>
            <el-button type="primary" :loading="loading" @click="conditionEditSubmit">确定</el-button>
        </template>
    </el-dialog>
</template>

<script>
import axios from "ts-axios-new";
import DateRangePicker from "../base/DateRangePicker";
import TestPlanPicker from "./TestPlanPicker.vue";
import {update} from "../libs/utils";
import {sortCmsCategoryOptions} from "../libs/categorySort.mjs";
import {ElMessage, ElMessageBox} from 'element-plus'
import {getProduct, getProductList} from "../libs/app";
import {has_gallery_delete_permission} from "../libs/permission";
import JSZip from 'jszip';
import {rememberAndRunBatchImageJob, retryBatchImageJob} from '../libs/batchImageRunner';
import {downloadResourcesAsZip} from '../libs/downloadUtils';
import {
    clientBatchConfigSignature,
    clientBatchFileIdentity,
    openClientBatchArchive,
    preprocessClientBatchImage,
    readClientBatchEntry,
} from '../libs/clientBatchImage';

const BATCH_IMAGE_JOB_STORAGE_PREFIX = 'jigsaw_batch_image_job_id';
const CLIENT_BATCH_IMAGE_STORAGE_PREFIX = 'jigsaw_client_batch_image';
const DIMENSION_REPAIR_JOB_STORAGE_PREFIX = 'jigsaw_dimension_repair_job_id';

export default {
    name: "Index",
    components: {DateRangePicker, TestPlanPicker},
    data() {
        return {
            loading: false, maxSize:2048, batchLoading:false, data: [], total: 0, page: 1, dialog_opened: false,dialogBatch_opened: false, dimensionRepairDialog: false, editing: null,
            category_list: [], major_list: [], minor_list: [], assistant_list: [],
            category_map: {}, major_map: {}, minor_map: {}, assistant_map: {}, source_list: [],
            edit_unauthorized : false,
            product_query_map: {"fantasy": "fantasy","classic": "classic", "none": "none"},
            props: {expandTrigger: 'hover', label: 'name', value: 'id', emitPath: false},
            multiSelectProps: {expandTrigger: 'hover', label: 'name', value: 'id', emitPath: false, multiple: true},
            query: {
                id: null,
                online: null,
                collection_usage: null,
                category_ids: [],
                products: [],
                status: null,
                source: null,
                module: null,
                major_tags: [],
                minor_tags: [],
                assistant_tags: [],
                test_state: null,
                test_direction: null,
                limit: 20,
                skip: 0,
                start: null,
                end: null,
                unauthorized: null,
                video: null,
                is_animated: null,
                include_achievement_usage: true,
            },
            form: {
                resource: '',
                animation: '',
                categories: [],
                cost: 0,
                platform: null,
                source: null,
                major_tags: [],
                minor_tags: [],
                assistant_tags: [],
                operation_tags: [],
                test_info: {
                    goal: '',
                    direction: '',
                    batch: '',
                    hypothesis: '',
                    duration_days: 7,
                    status: 'WAITING',
                },
                module: 'LIBRARY',
                modules: {},
                activity: null,
                status: null,
                online_date: null,
                include_country: [],
                exclude_country: [],
                desc: null,
                unauthorized: null,
                product: [],
            },
            batchForm: {
                file: null,
                categories: [],
                module: 'LIBRARY',
                product: [],
                needs_ai_tag: true,
                force_resize: false,
                client_preprocess: true,
                test_info: {
                    goal: '',
                    direction: '',
                    hypothesis: '',
                    duration_days: 7,
                    status: 'WAITING',
                },
            },
            batchProgress: {
                visible: false,
                percent: 0,
                status: undefined,
                text: '',
                errors: [],
                jobId: null,
                timer: null,
                pollFailures: 0,
                uploadingChunks: false,
                jobStatus: null,
                success: 0,
                diagnostics: [],
                cancelRequested: false,
                clientPaused: false,
                clientMode: false,
            },
            batchUploadAbortController: null,
            clientBatchAbortController: null,
            dimensionRepair: {
                job: null,
                form: {start: null, end: null, source_width: 1920, source_height: 1920},
                timer: null,
                running: false,
                pollFailures: 0,
                percent: 0,
                progressStatus: undefined,
                text: '',
            },
            fileList: [],
            idList: [],
            selectedItems: new Set(),
            selectedImageMap: new Map(),
            downloadingImages: false,
            batchTagDialog: false,
            batchTestDialog: false,
            batchTestForm: {
                goal: '',
                direction: '',
                hypothesis: '',
                duration_days: 7,
                status: 'WAITING',
            },
            tagMode: 'add', // 'add' 追加模式, 'delete' 删除模式
            batchTagForm: {
                major_tags: [],
                minor_tags: [],
                assistant_tags: [],
                categories: [],
                product: [],
                modules: {}
            },
            commonTags: {
                major_tags: [],
                minor_tags: [],
                assistant_tags: [],
                categories: [],
                product: []
            },
            conditionEditDialog: false,
            conditionQuery: {
                id: null,
                online: null,
                category_ids: [],
                products: [],
                status: null,
                source: null,
                module: null,
                major_tags: [],
                minor_tags: [],
                assistant_tags: [],
                start: null,
                end: null,
                unauthorized: null,
                video: null,
                is_animated: null,
            },
            conditionEditForm: {
                product: [],
                productMode: 'add',
                categories: [],
                categoriesMode: 'add',
                major_tags: [],
                majorTagsMode: 'add',
                minor_tags: [],
                minorTagsMode: 'add',
                assistant_tags: [],
                assistantTagsMode: 'add',
                include_country: [],
                includeCountryMode: 'add',
                exclude_country: [],
                excludeCountryMode: 'add',
                status: null,
                cost: null,
                online_date: null,
                platform: null,
                source: null,
                module: null,
                modules: {},
                unauthorized: null
            }
        }
    },
    computed: {
        canDeleteGallery() {
            return has_gallery_delete_permission();
        },
        batchTestCategories() {
            const ids = new Set();
            this.selectedImages().forEach(image => (image.categories || []).forEach(id => ids.add(id)));
            return Array.from(ids);
        },
      editButton() {
        if (this.edit_unauthorized) {
          return {
            type: 'danger',
            text: '取消编辑状态'
          };
        } else {
          return {
            type: 'primary',
            text: '进入编辑状态'
          };
        }
      },
    },
    watch: {
      'form.product'(newVal) {
        const products = newVal || [];
        const next = {};
        products.forEach(k => {
          next[k] = k in this.form.modules ? this.form.modules[k] : null;
        });
        this.form.modules = next;
      },
      // When tagMode changes, update common tags or reset form
      tagMode(newMode) {
        this.batchTagForm.major_tags = [];
        this.batchTagForm.minor_tags = [];
        this.batchTagForm.assistant_tags = [];
        this.batchTagForm.categories = [];
        this.batchTagForm.product = [];
        
        if (newMode === 'delete' && this.idList.length > 0) {
          this.calculateCommonTags();
        } else {
          this.commonTags.major_tags = [];
          this.commonTags.minor_tags = [];
          this.commonTags.assistant_tags = [];
          this.commonTags.categories = [];
          this.commonTags.product = [];
        }
      }
    },
    methods: {
        getProduct,
        getProductList,
        isClassicProduct() {
            return getProduct()?.key === 'classic';
        },
        getErrorMessage(err, fallback = '操作失败') {
            return err.response?.data?.status?.message
                || err.response?.data?.status?.msg
                || err.response?.data?.message
                || err.message
                || fallback;
        },
        getBatchChunkErrorMessage(err) {
            const status = err.response?.status;
            const message = this.getErrorMessage(err, '网络连接中断或网关未响应');
            if (status) {
                return `HTTP ${status}${message ? `：${message}` : ''}`;
            }
            if (err.code) {
                return `${err.code}：${message}`;
            }
            return message;
        },
        normalizeQueryParams(query) {
            const params = {...query};
            ['category_ids', 'products', 'major_tags', 'minor_tags', 'assistant_tags'].forEach(key => {
                if (params[key] && params[key].length > 0) {
                    params[key] = params[key].join(',');
                } else {
                    delete params[key];
                }
            });
            return params;
        },
        emptyTestInfo() {
            return {goal: '', direction: '', batch: '', hypothesis: '', duration_days: 7, status: 'WAITING'};
        },
        normalizedTestInfo(value) {
            const direction = String(value?.direction || '').trim();
            if (!direction) return null;
            return {
                goal: value?.goal || 'OTHER',
                direction,
                batch: String(value?.batch || '').trim(),
                hypothesis: String(value?.hypothesis || '').trim(),
                duration_days: Number(value?.duration_days) || 7,
                status: value?.status || 'WAITING',
            };
        },
        imagePayload() {
            return {...this.form, test_info: this.normalizedTestInfo(this.form.test_info)};
        },
        resourceUrl(resource) {
            if (!resource) {
                return '';
            }
            if (/^https?:\/\//.test(resource)) {
                return resource;
            }
            const cdn = import.meta.env.VITE_CDN_URL || 'https://jigsaw-cdn.plutodesk.com';
            return `${cdn.replace(/\/$/, '')}/${resource}`;
        },
        getProductName(key) {
            const product = getProductList().find(p => p.key === key);
            return product ? product.name : key;
        },
        sharedProductKeys(row) {
            return [...new Set((row?.product || []).filter(Boolean))];
        },
        sharedProductNames(row) {
            return this.sharedProductKeys(row).map(key => this.getProductName(key));
        },
        // Legacy（classic）永远免费：服务端对 classic 强制 cost=0，客户端也不下发 cost，
        // 所以共享产品里的 classic 并不参与价格归属，不能因此锁住改价。
        costCoupledProductKeys(row) {
            return this.sharedProductKeys(row).filter(key => key !== 'classic');
        },
        costCoupledProductNames(row) {
            return this.costCoupledProductKeys(row).map(key => this.getProductName(key));
        },
        isPriceEditLocked(row) {
            // 只有 Legacy 页面需要锁价（服务端对它强制 cost=0，改了也没有意义）。
            // 其余产品允许就地改价；若价格被多个产品共用，changeCost 会先二次确认。
            return this.isClassicProduct();
        },
        priceEditHint(row) {
            if (this.isClassicProduct()) {
                return 'Legacy 图片价格固定为 0';
            }
            const coupled = this.costCoupledProductNames(row);
            if (coupled.length > 1) {
                return `该价格同时用于：${coupled.join('、')}，修改前会二次确认`;
            }
            if (this.sharedProductKeys(row).includes('classic') && this.sharedProductKeys(row).length > 1) {
                return 'Legacy 不使用图片价格，可直接修改，不会影响其它产品';
            }
            return '';
        },
        deleteConfirmText(row) {
            const productNames = this.sharedProductNames(row);
            if (productNames.length > 1) {
                const currentProduct = getProduct()?.key;
                const currentName = this.getProductName(currentProduct);
                const remainingNames = this.sharedProductKeys(row)
                    .filter(key => key !== currentProduct)
                    .map(key => this.getProductName(key));
                return `这张图片同时用于：${productNames.join('、')}。本次仅从当前产品「${currentName}」移除，不会删除图片资源，也不会影响${remainingNames.join('、')}继续使用。`;
            }
            return '确定要删除该项吗？删除后将立即彻底删除图片记录，不可恢复。';
        },
        deleteResultText(result) {
            if (result?.delete_action === 'detached_from_product') {
                const detached = this.getProductName(result.detached_product);
                const remaining = (result.remaining_products || []).map(key => this.getProductName(key));
                return `已仅从${detached}移除；图片仍由${remaining.join('、')}使用`;
            }
            return '已彻底删除';
        },
        otherProductList() {
            const current = getProduct()?.key;
            return getProductList().filter(product => product.key !== current);
        },
        init() {
            this.loading = true;
            const params = this.normalizeQueryParams(this.query);
            return axios.get(`/cms/v1/image`, {params: params}).then(res => {
                this.data = res.data.data.imageList;
                this.total = res.data.data.total;
            }).catch(err => {
                ElMessage.error('加载图片列表失败: ' + this.getErrorMessage(err));
            }).finally(() => {
                this.loading = false;
                this.checkCurrentPageAssets();
            });
        },
        checkCurrentPageAssets() {
            const ids = this.data.map(item => item.id).filter(Boolean);
            if (!ids.length) {
                return;
            }
            axios.post('/cms/v1/image/assets/check', {ids}).then(res => {
                const assets = res.data.data.assets || [];
                const assetMap = {};
                assets.forEach(item => {
                    assetMap[item.id] = item.missing_assets || [];
                });
                this.data.forEach(item => {
                    item.missing_assets = assetMap[item.id] || [];
                });
            }).catch(() => {});
        },
        assetIssueText(missingAssets) {
            const reasonMap = {
                empty: '为空',
                'not found': '不存在',
                'invalid path': '路径错误',
            };
            return missingAssets
                .map(item => `${item.field}${reasonMap[item.reason] || item.reason}`)
                .join('、');
        },
        reload() {
            if (!this.query.id || this.query.id.length === 24) {
                this.clearAllSelection();
                this.skip = 0;
                this.page = 1;
                this.init();
            }
        },
        df(map, list) {
            list.forEach(l => {
                map[l.id] = l.name;
                if (l.children.length) {
                    this.df(map, l.children);
                }
            });
        },
        pageChange(page) {
            this.query.skip = (page - 1) * this.query.limit;
            this.init();
        },
        update(row, field) {
            // 价格允许就地修改（跨产品共用价格时由 changeCost 二次确认）；
            // 审核状态、版权等全局字段仍要求走编辑弹窗确认跨产品影响。
            if (field !== 'cost' && this.sharedProductKeys(row).length > 1) {
                ElMessage.warning('历史共享图片请点击“编辑”，阅读跨产品影响提示后再修改');
                this.init();
                return;
            }
            const persist = () => {
                row._saving = true;
                return axios.put(`/cms/v1/image/${row.id}`, row).then(res => {
                    update(row, res.data.data);
                }).catch(err => {
                    ElMessage.error('保存图片失败: ' + this.getErrorMessage(err));
                }).finally(() => {
                    row._saving = false;
                });
            };
            persist();
        },
        changeCost(row) {
            const coupled = this.costCoupledProductNames(row);
            if (coupled.length <= 1) {
                // 只与 Legacy 共享（或自有图片）：价格只影响当前产品，直接保存。
                this.update(row, 'cost');
                return;
            }
            ElMessageBox.confirm(
                `这张图片的价格同时用于：${coupled.join('、')}。改价会立即影响这些产品的线上展示，确认继续吗？`,
                '确认修改共享图片价格',
                {confirmButtonText: '继续保存', cancelButtonText: '取消', type: 'warning'},
            ).then(() => {
                this.update(row, 'cost');
            }).catch(() => {
                // 取消时重新拉取，回滚列表里已经变更的下拉值。
                this.init();
            });
        },
        updateOnlineDate(row) {
          const selectedDate = row.online_date;
          row._saving = true;
          axios.put(`/cms/v1/online/image/${row.id}`, { online_date: row.online_date}).then(res => {
            update(row, res.data.data);
            row.online_date = res.data.data.online_date || selectedDate;
          }).catch(err => {
            ElMessage.error('保存上线时间失败: ' + this.getErrorMessage(err));
          }).finally(() => {
            row._saving = false;
          });
        },
        updateUnauthorized(row) {
          this.update(row);
        },
        openEdit() {
          this.edit_unauthorized = !this.edit_unauthorized;
        },
        openDialog(item) {
            this.dialog_opened = true;
            this.$nextTick(_ => {
                if (item) {
                    this.form.modules = {};
                    update(this.form, item);
                    const baseModules = item.modules ? { ...item.modules } : {};
                    const products = item.product || [];
                    const next = {};
                    products.forEach(productId => {
                        next[productId] = productId in baseModules ? baseModules[productId] : null;
                    });
                    this.form.modules = next;
                    this.form.test_info = item.test_info
                        ? {...this.emptyTestInfo(), ...item.test_info}
                        : this.emptyTestInfo();
                    this.editing = item;
                } else {
                    this.form.test_info = this.emptyTestInfo();
                }
            })
        },
        openBatchDialog() {
            this.batchForm.product = [getProduct().key];
            const state = this.readClientBatchState();
            if (state?.config) {
                this.batchForm.categories = [...(state.config.categories || [])];
                this.batchForm.module = state.config.module || 'LIBRARY';
                this.batchForm.needs_ai_tag = Boolean(state.config.needs_ai_tag);
                this.batchForm.force_resize = Boolean(state.config.force_resize);
                this.batchForm.test_info = state.config.test_info
                    ? {...this.emptyTestInfo(), ...state.config.test_info}
                    : this.emptyTestInfo();
                this.batchForm.client_preprocess = true;
            }
            this.dialogBatch_opened = true;
        },
        beforeCloseBatchDialog(done) {
            if (this.batchLoading) {
                if (this.batchProgress.clientMode) {
                    ElMessage.info('本机处理任务会继续运行，可在页面顶部查看进度');
                    done();
                    return;
                }
                ElMessage.warning('正在上传压缩包，请等待上传完成');
                return;
            }
            this.batchReset();
            done();
        },
        reset() {
            this.$refs.form.resetFields();
            this.loading = this.dialog_opened = false;
            this.editing = null;
            this.form.platform = null;
            this.form.categories = [];
            this.form.major_tags = [];
            this.form.minor_tags = [];
            this.form.assistant_tags = [];
            this.form.include_country = [];
            this.form.exclude_country = [];
            this.form.unauthorized = null;
            this.form.modules = {};
            this.form.animation = '';
            this.form.test_info = this.emptyTestInfo();
        },
        batchReset(){
            this.$refs.batchForm.resetFields();
            this.batchLoading = this.dialogBatch_opened = false;
            this.batchForm.categories = [];
            this.batchForm.file = null;
            this.batchForm.module='LIBRARY';
            this.batchForm.product = [getProduct().key]
            this.batchForm.needs_ai_tag = true;
            this.batchForm.force_resize = false;
            this.batchForm.client_preprocess = true;
            this.batchForm.test_info = this.emptyTestInfo();
            this.fileList = [];
            if (!this.batchProgress.jobId && !this.readClientBatchState()) {
                this.resetBatchProgress();
            }
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    const persist = () => {
                      this.loading = true;
                      const payload = this.imagePayload();
                      if (this.editing) {
                          axios.put(`/cms/v1/image/${this.editing.id}`, payload).then(res => {
                              if (res.data.data.source && !this.source_list.includes(res.data.data.source)) {
                                  this.source_list.push(res.data.data.source);
                              }
                              update(this.editing, res.data.data);
                              this.reset();
                          }).catch(err => {
                              ElMessage.error('保存图片失败: ' + this.getErrorMessage(err));
                          }).finally(() => {
                              this.loading = false;
                          });
                      } else {
                          axios.post('/cms/v1/image', payload).then(res => {
                              if (!this.source_list.includes(res.data.data.source)) {
                                  this.source_list.push(res.data.data.source);
                              }
                              this.data.unshift(res.data.data);
                              this.reset();
                          }).catch(err => {
                              ElMessage.error('创建图片失败: ' + this.getErrorMessage(err));
                          }).finally(() => {
                              this.loading = false;
                          });
                      }
                    };
                    if (this.editing) {
                        if (this.sharedProductKeys(this.editing).length > 1) {
                            ElMessageBox.confirm(
                                `这是跨产品共享的历史图片，保存会同时影响：${this.sharedProductNames(this.editing).join('、')}。确认继续吗？`,
                                '确认修改共享图片',
                                {confirmButtonText: '继续保存', cancelButtonText: '取消', type: 'warning'},
                            ).then(persist).catch(() => {});
                        } else {
                            persist();
                        }
                    } else {
                        persist();
                    }
                }
            })
        },
        handleBatchFileChange(file, fileList) {
             if (fileList.length > 1) {
                fileList.splice(0, 1);
            }
            const isZip = file.raw && this.isZipFile(file.raw);
            if (!isZip) {
                this.$message.error('只能上传 ZIP 压缩包');
                this.fileList = [];
                this.batchForm.file = null;
                return;
            }
            if (file.size <= 0) {
                this.$message.error('不能上传空压缩包');
                this.fileList = [];
                this.batchForm.file = null;
                return;
            }
            const maxSize = this.maxSize * 1024 * 1024;
            if (file.size > maxSize) {
                this.$message.error(`文件大小不能超过${this.maxSize}MB！`);
                this.fileList = [];
                this.batchForm.file = null;
                return;
            }
            this.fileList = fileList;
            this.batchForm.file = file;
        },
        isZipFile(file) {
            return file.type === 'application/zip' || file.type === 'application/x-zip-compressed' || file.name.toLowerCase().endsWith('.zip');
        },
        batchBeforeUpload(file){
            const isZip = this.isZipFile(file);
            if (!isZip) {
                this.$message.error('只能上传 ZIP 压缩包');
                return false;
            }
            const isLtMax = file.size  <= this.maxSize * 1024 * 1024;
            if (!isLtMax) {
                this.$message.error(`文件大小不能超过${this.maxSize}MB`);
                return false;
            }
            return true;
        },
        handleRemove(file, fileList) {
            this.fileList = fileList;
            this.batchForm.file = null;
        },
        handleExceed(){
            this.$message.warning('只能上传一个文件，请先删除当前文件再上传新文件')
        },
        dimensionRepairStorageKey() {
            return `${DIMENSION_REPAIR_JOB_STORAGE_PREFIX}:${getProduct().key}`;
        },
        storeDimensionRepairJob(jobId) {
            if (jobId) {
                localStorage.setItem(this.dimensionRepairStorageKey(), jobId);
            }
        },
        clearStoredDimensionRepairJob() {
            localStorage.removeItem(this.dimensionRepairStorageKey());
        },
        openDimensionRepairDialog() {
            this.dimensionRepairDialog = true;
        },
        resetDimensionRepair() {
            if (this.dimensionRepair.timer) {
                clearTimeout(this.dimensionRepair.timer);
            }
            this.clearStoredDimensionRepairJob();
            this.dimensionRepair.job = null;
            this.dimensionRepair.running = false;
            this.dimensionRepair.pollFailures = 0;
            this.dimensionRepair.percent = 0;
            this.dimensionRepair.progressStatus = undefined;
            this.dimensionRepair.text = '';
        },
        updateDimensionRepair(job) {
            if (!job) return;
            const scanning = job.status === 'pending' || job.status === 'scanning';
            const repairing = job.status === 'repairing';
            const total = job.total || 0;
            const checked = job.checked || 0;
            const done = job.done || 0;
            let percent = 0;
            let text = job.status_message || '';
            let status;
            if (scanning) {
                percent = total ? Math.floor(checked * 100 / total) : 0;
                text = text || `正在扫描：${checked}/${total}`;
            } else if (job.status === 'scan_finished') {
                percent = 100;
                status = 'success';
                text = `扫描完成：检查 ${checked}/${total}，发现 ${job.candidate_count || 0} 张可修复图片`;
            } else if (repairing) {
                const candidates = job.candidate_count || total;
                percent = candidates ? Math.floor(done * 100 / candidates) : 0;
                text = text || `正在修复：成功 ${job.success || 0}，跳过 ${job.skipped || 0}，失败 ${job.failed || 0}`;
            } else if (job.status === 'finished' || job.status === 'finished_with_errors') {
                percent = 100;
                status = job.status === 'finished' ? 'success' : 'warning';
                text = `修复完成：成功 ${job.success || 0}，跳过 ${job.skipped || 0}，失败 ${job.failed || 0}`;
            } else if (job.status === 'failed') {
                status = 'exception';
                text = `任务失败：${job.error_message || '未知错误'}`;
            }
            this.dimensionRepair.job = job;
            this.dimensionRepair.percent = Math.min(100, percent);
            this.dimensionRepair.progressStatus = status;
            this.dimensionRepair.text = text;
            this.dimensionRepair.running = scanning || repairing;
            this.dimensionRepair.pollFailures = 0;
            if (['finished', 'finished_with_errors', 'failed'].includes(job.status)) {
                this.clearStoredDimensionRepairJob();
            } else {
                this.storeDimensionRepairJob(job.id);
            }
        },
        formatDimensionRepairImpact(products) {
            return Object.entries(products || {})
                .map(([product, count]) => `${product} ${count} 条`)
                .join('、') || '无';
        },
        async pollDimensionRepairJob(jobId, showFinishMessage = true) {
            try {
                const res = await axios.get(`/cms/v1/image/dimension-repair/job/${jobId}`);
                const job = res.data.data.job;
                this.updateDimensionRepair(job);
                if (job.status === 'scan_finished') {
                    this.dimensionRepair.running = false;
                    return;
                }
                if (['finished', 'finished_with_errors', 'failed'].includes(job.status)) {
                    this.dimensionRepair.running = false;
                    if (showFinishMessage) {
                        if (job.status === 'finished') {
                            ElMessage.success(`图片尺寸修复完成：成功 ${job.success || 0} 张`);
                        } else if (job.status === 'finished_with_errors') {
                            ElMessage.warning(`图片尺寸修复完成：成功 ${job.success || 0} 张，失败 ${job.failed || 0} 张`);
                        } else {
                            ElMessage.error(job.error_message || '图片尺寸修复失败');
                        }
                    }
                    return;
                }
            } catch (err) {
                this.dimensionRepair.pollFailures += 1;
                if (this.dimensionRepair.pollFailures >= 5) {
                    this.dimensionRepair.running = false;
                    ElMessage.error('查询图片尺寸修复进度失败: ' + this.getErrorMessage(err));
                    return;
                }
            }
            this.dimensionRepair.timer = setTimeout(() => {
                this.pollDimensionRepairJob(jobId, showFinishMessage);
            }, 2000);
        },
        async startDimensionRepairScan() {
            const {start, end, source_width, source_height} = this.dimensionRepair.form;
            if (!start || !end) {
                ElMessage.warning('请选择需要检查的导入时间范围');
                return;
            }
            this.dimensionRepair.running = true;
            try {
                const res = await axios.post('/cms/v1/image/dimension-repair/job', {
                    start,
                    end,
                    source_width,
                    source_height,
                });
                this.updateDimensionRepair(res.data.data.job);
                await this.pollDimensionRepairJob(res.data.data.job.id, false);
            } catch (err) {
                this.dimensionRepair.running = false;
                ElMessage.error('启动图片尺寸扫描失败: ' + this.getErrorMessage(err));
            }
        },
        async confirmDimensionRepair() {
            const job = this.dimensionRepair.job;
            if (!job || !job.candidate_count) return;
            try {
                await ElMessageBox.confirm(
                    `将备份并覆盖修复 ${job.candidate_count} 个资源，影响 ${job.impact_count || job.candidate_count} 条图片记录。所有产品统一使用 2048×2048，共享引用会同步生效；CDN 缓存可能需要等待刷新后生效。确认继续吗？`,
                    '确认修复图片尺寸',
                    {type: 'warning', confirmButtonText: '确认修复', cancelButtonText: '取消'},
                );
            } catch (_) {
                return;
            }
            this.dimensionRepair.running = true;
            try {
                const res = await axios.post(`/cms/v1/image/dimension-repair/job/${job.id}/apply`);
                this.updateDimensionRepair(res.data.data.job);
                await this.pollDimensionRepairJob(job.id);
            } catch (err) {
                this.dimensionRepair.running = false;
                ElMessage.error('启动图片尺寸修复失败: ' + this.getErrorMessage(err));
            }
        },
        restoreDimensionRepairJob() {
            const jobId = localStorage.getItem(this.dimensionRepairStorageKey());
            if (!jobId) return;
            this.dimensionRepair.running = true;
            this.dimensionRepair.text = '正在恢复图片尺寸修复进度...';
            this.pollDimensionRepairJob(jobId, false);
        },
        resetBatchProgress() {
            if (this.batchProgress.timer) {
                clearTimeout(this.batchProgress.timer);
            }
            this.clearStoredBatchImageJob();
            this.batchProgress = {
                visible: false,
                percent: 0,
                status: undefined,
                text: '',
                errors: [],
                jobId: null,
                timer: null,
                pollFailures: 0,
                uploadingChunks: false,
                jobStatus: null,
                success: 0,
                diagnostics: [],
                cancelRequested: false,
                clientPaused: false,
                clientMode: false,
            };
        },
        batchImageJobStorageKey() {
            return `${BATCH_IMAGE_JOB_STORAGE_PREFIX}:${getProduct().key}`;
        },
        batchUploadingJobStorageKey() {
            return `${BATCH_IMAGE_JOB_STORAGE_PREFIX}:uploading:${getProduct().key}`;
        },
        storeBatchImageJob(jobId) {
            if (jobId) {
                localStorage.setItem(this.batchImageJobStorageKey(), jobId);
            }
        },
        storeUploadingBatchImageJob(jobId) {
            if (jobId) {
                sessionStorage.setItem(this.batchUploadingJobStorageKey(), jobId);
            }
        },
        clearStoredBatchImageJob() {
            localStorage.removeItem(this.batchImageJobStorageKey());
            sessionStorage.removeItem(this.batchUploadingJobStorageKey());
        },
        clientBatchStorageKey() {
            return `${CLIENT_BATCH_IMAGE_STORAGE_PREFIX}:${getProduct().key}`;
        },
        readClientBatchState() {
            try {
                const value = localStorage.getItem(this.clientBatchStorageKey());
                return value ? JSON.parse(value) : null;
            } catch (_) {
                localStorage.removeItem(this.clientBatchStorageKey());
                return null;
            }
        },
        writeClientBatchState(state) {
            localStorage.setItem(this.clientBatchStorageKey(), JSON.stringify(state));
        },
        clearClientBatchState() {
            localStorage.removeItem(this.clientBatchStorageKey());
        },
        handleBeforeUnload(event) {
            if (!this.batchProgress.uploadingChunks && !(this.batchProgress.clientMode && this.batchLoading)) {
                return;
            }
            event.preventDefault();
            event.returnValue = this.batchProgress.clientMode
                ? '图片正在由本机处理，刷新会暂停任务，重新选择原 ZIP 后可以继续。'
                : '压缩包还在上传中，刷新会中断上传。';
        },
        updateBatchProgress(job) {
            if (!job) return;
            const uploading = job.status === 'uploading';
            const totalChunks = job.total_chunks || 0;
            const receivedChunks = job.received_chunks || 0;
            const total = job.total || 0;
            const done = job.done || 0;
            let percent = 0;
            let text = '';
            let status;
            if (uploading) {
                percent = totalChunks ? Math.floor(receivedChunks * 30 / totalChunks) : 0;
                text = `上传压缩包中：${receivedChunks}/${totalChunks} 分片`;
            } else if (job.status === 'merging' || job.status === 'planning') {
                percent = 32;
                text = job.status_message || '压缩包已上传，正在合并分片';
            } else if (job.status === 'pending') {
                percent = 35;
                text = '压缩包已上传，等待后台导入';
            } else if (job.status === 'running' && !total) {
                percent = 35;
                text = job.status_message || '后台导入中：正在扫描压缩包';
            } else {
                percent = total ? 35 + Math.floor(done * 65 / total) : 35;
                const progress = `后台导入中：成功 ${job.success || 0} 张，失败 ${job.failed || 0} 张`;
                text = job.status_message ? `${progress}；${job.status_message}` : progress;
            }
            if (job.status === 'finished') {
                percent = 100;
                status = 'success';
                text = `批量导入完成：成功 ${job.success || 0} 张`;
            } else if (job.status === 'finished_with_errors') {
                percent = 100;
                status = 'warning';
                text = `批量导入完成：成功 ${job.success || 0} 张，失败 ${job.failed || 0} 张`;
            } else if (job.status === 'failed') {
                status = 'exception';
                text = `批量导入失败：${job.error_message || '未知错误'}`;
            } else if (job.status === 'cancelled') {
                status = 'exception';
                text = `批量导入已取消：${job.error_message || '已停止'}`;
            }
            this.batchProgress.visible = true;
            this.batchProgress.percent = Math.min(100, percent);
            this.batchProgress.status = status;
            this.batchProgress.text = text;
            this.batchProgress.errors = job.errors || [];
            this.batchProgress.jobId = job.id;
            this.batchProgress.pollFailures = 0;
            this.batchProgress.uploadingChunks = uploading;
            this.batchProgress.jobStatus = job.status;
            this.batchProgress.success = job.success || 0;
            this.batchProgress.diagnostics = job.diagnostics || [];
            if (job.client_paused) {
                this.batchProgress.clientPaused = true;
                this.batchProgress.status = 'exception';
            } else if (!this.batchProgress.clientPaused) {
                this.batchProgress.clientPaused = false;
            }
            if (['finished', 'finished_with_errors', 'failed', 'cancelled'].includes(job.status)) {
                this.clearStoredBatchImageJob();
            } else if (uploading) {
                localStorage.removeItem(this.batchImageJobStorageKey());
                this.storeUploadingBatchImageJob(job.id);
            } else {
                sessionStorage.removeItem(this.batchUploadingJobStorageKey());
                this.storeBatchImageJob(job.id);
            }
        },
        handleBatchImageJobUpdate(event) {
            const detail = event && event.detail;
            if (!detail || detail.product !== getProduct().key || !detail.job) return;
            this.updateBatchProgress(detail.job);
            if (detail.job.client_paused) {
                if (this.batchProgress.timer) {
                    clearTimeout(this.batchProgress.timer);
                    this.batchProgress.timer = null;
                }
                return;
            }
            if (['finished', 'finished_with_errors'].includes(detail.job.status)) {
                this.reload();
            }
        },
        isBatchJobCancellable() {
            if (this.batchProgress.clientMode && (this.batchLoading || this.readClientBatchState())) return true;
            return Boolean(this.batchProgress.jobId) && ['uploading', 'merging', 'planning', 'pending', 'ready', 'running'].includes(this.batchProgress.jobStatus);
        },
        retryPausedBatchImageJob() {
            const jobId = this.batchProgress.jobId;
            if (!jobId) return;
            this.batchProgress.clientPaused = false;
            this.batchProgress.status = undefined;
            this.batchProgress.text = '正在重新连接后台导入任务...';
            retryBatchImageJob(jobId, getProduct().key);
            this.pollBatchImageJob(jobId);
        },
        formatBatchDiagnosticElapsed(elapsedMs) {
            const value = Number(elapsedMs || 0);
            return `${(value / 1000).toFixed(value >= 10000 ? 0 : 1)}s`;
        },
        async uploadBatchChunk(jobId, chunkIndex, chunk, filename) {
            let lastError;
            for (let attempt = 0; attempt < 3; attempt += 1) {
                if (this.batchProgress.cancelRequested) {
                    const cancelled = new Error('批量上传已取消');
                    cancelled.batchUploadCancelled = true;
                    throw cancelled;
                }
                try {
                    const form = new FormData();
                    form.append('chunk_index', chunkIndex);
                    form.append('file', chunk, `${filename}.part${chunkIndex}`);
                    return await axios.post(`/cms/v1/batch-image/job/${jobId}/chunk`, form, {
                        signal: this.batchUploadAbortController?.signal,
                    });
                } catch (error) {
                    if (this.batchProgress.cancelRequested) {
                        if (error && typeof error === 'object') {
                            error.batchUploadCancelled = true;
                            throw error;
                        }
                        const cancelled = new Error('批量上传已取消');
                        cancelled.batchUploadCancelled = true;
                        throw cancelled;
                    }
                    lastError = error;
                    if (attempt < 2) {
                        this.batchProgress.text = `上传第 ${chunkIndex + 1} 个分片失败，正在重试（${attempt + 1}/2）`;
                        await new Promise(resolve => setTimeout(resolve, attempt === 0 ? 1000 : 3000));
                    }
                }
            }
            if (lastError) {
                lastError.batchChunkIndex = chunkIndex;
                lastError.batchChunkErrorMessage = this.getBatchChunkErrorMessage(lastError);
            }
            throw lastError;
        },
        async cancelBatchImageJob() {
            const jobId = this.batchProgress.jobId;
            if (!this.isBatchJobCancellable()) return;
            try {
                await ElMessageBox.confirm(
                    '取消后将停止后续导入；已成功导入的图片不会回滚，正在处理的当前一张可能完成。确认取消吗？',
                    '取消批量上传',
                    {type: 'warning', confirmButtonText: '确认取消', cancelButtonText: '继续等待'},
                );
            } catch (_) {
                return;
            }
            this.batchProgress.cancelRequested = true;
            if (this.batchProgress.clientMode) {
                if (this.clientBatchAbortController) this.clientBatchAbortController.abort();
                this.clearClientBatchState();
                this.batchLoading = false;
                this.dialogBatch_opened = false;
                this.batchProgress.status = 'exception';
                this.batchProgress.text = '本机批量任务已取消；已成功导入的图片不会回滚';
                ElMessage.success('已取消本机批量任务');
                return;
            }
            if (!jobId) return;
            if (this.batchUploadAbortController) {
                this.batchUploadAbortController.abort();
            }
            try {
                const res = await axios.delete(`/cms/v1/batch-image/job/${jobId}`);
                this.updateBatchProgress(res.data.data.job);
                this.batchLoading = false;
                this.dialogBatch_opened = false;
                ElMessage.success('已取消任务，可以重新上传压缩包');
            } catch (err) {
                ElMessage.error('取消批量上传失败: ' + this.getErrorMessage(err));
            }
        },
        async restartBatchUpload() {
            if (this.batchProgress.success > 0) {
                try {
                    await ElMessageBox.confirm(
                        `当前任务已经成功导入 ${this.batchProgress.success} 张图片。重新上传同一压缩包会重复创建这些图片，确认继续吗？`,
                        '确认重新上传',
                        {type: 'warning', confirmButtonText: '仍要重新上传', cancelButtonText: '取消'},
                    );
                } catch (_) {
                    return;
                }
            }
            this.clearClientBatchState();
            this.resetBatchProgress();
            this.batchLoading = false;
            this.dialogBatch_opened = true;
        },
        async pollBatchImageJob(jobId, showFinishMessage = true) {
            if (this.batchProgress.clientPaused) return;
            try {
                const res = await axios.get(`/cms/v1/batch-image/job/${jobId}`);
                const job = res.data.data.job;
                if (this.batchProgress.clientPaused) return;
                if (job.status === 'uploading') {
                    const uploadComplete = Number(job.received_chunks || 0) >= Number(job.total_chunks || 0)
                        && Number(job.total_chunks || 0) > 0;
                    if (uploadComplete) {
                        this.updateBatchProgress(job);
                        rememberAndRunBatchImageJob(job.id, getProduct().key);
                        this.batchProgress.timer = setTimeout(() => {
                            this.pollBatchImageJob(jobId, showFinishMessage);
                        }, 1000);
                        return;
                    }
                    const cancelRes = await axios.delete(`/cms/v1/batch-image/job/${jobId}`);
                    this.updateBatchProgress(cancelRes.data.data.job);
                    this.batchProgress.text = '页面刷新时压缩包尚未传完，已取消未完成任务，请重新选择压缩包上传。';
                    this.batchLoading = false;
                    this.batchProgress.uploadingChunks = false;
                    return;
                }
                this.updateBatchProgress(job);
                if (['merging', 'planning', 'ready', 'running'].includes(job.status)) {
                    rememberAndRunBatchImageJob(job.id, getProduct().key);
                }
                if (['finished', 'finished_with_errors', 'failed', 'cancelled'].includes(job.status)) {
                    this.batchLoading = false;
                    this.batchProgress.jobId = null;
                    if (this.batchProgress.timer) {
                        clearTimeout(this.batchProgress.timer);
                        this.batchProgress.timer = null;
                    }
                    if (showFinishMessage) {
                        if (job.status === 'finished') {
                            ElMessage.success(`批量导入完成：成功 ${job.success || 0} 张`);
                        } else if (job.status === 'finished_with_errors') {
                            ElMessage.warning(`批量导入完成：成功 ${job.success || 0} 张，失败 ${job.failed || 0} 张`);
                        } else if (job.status === 'cancelled') {
                            ElMessage.warning('批量导入已取消，已成功导入的图片不会回滚');
                        } else {
                            ElMessage.error(`批量导入失败：${job.error_message || '未知错误'}`);
                        }
                    }
                    if (['finished', 'finished_with_errors'].includes(job.status)) {
                        this.reload();
                    }
                    return;
                }
            } catch (err) {
                this.batchProgress.pollFailures = (this.batchProgress.pollFailures || 0) + 1;
                if (this.batchProgress.pollFailures >= 5) {
                    this.batchLoading = false;
                    this.batchProgress.status = 'exception';
                    this.batchProgress.text = '暂时无法查询后台导入进度，请稍后刷新页面重试。';
                    this.batchProgress.uploadingChunks = false;
                    this.batchProgress.jobId = jobId;
                    this.storeBatchImageJob(jobId);
                    ElMessage.error('查询批量导入进度失败: ' + this.getErrorMessage(err));
                    return;
                }
            }
            this.batchProgress.timer = setTimeout(() => {
                this.pollBatchImageJob(jobId, showFinishMessage);
            }, 2000);
        },
        restoreBatchImageJob() {
            const jobId = localStorage.getItem(this.batchImageJobStorageKey())
                || sessionStorage.getItem(this.batchUploadingJobStorageKey());
            if (!jobId) {
                const state = this.readClientBatchState();
                if (state) {
                    const completed = (state.completed || []).length;
                    this.batchProgress.visible = true;
                    this.batchProgress.clientMode = true;
                    this.batchProgress.success = completed;
                    this.batchProgress.percent = state.total ? Math.floor(completed * 100 / state.total) : 0;
                    this.batchProgress.status = 'warning';
                    this.batchProgress.text = `本机处理曾中断：已完成 ${completed}/${state.total || '?'}，请重新选择原 ZIP 继续`;
                }
                return;
            }
            this.batchLoading = true;
            this.batchProgress.visible = true;
            this.batchProgress.text = '正在恢复批量导入进度...';
            this.pollBatchImageJob(jobId, false);
        },
        zipBaseName(filename) {
            const cleanName = filename.split('/').pop();
            return cleanName.replace(/\.[^.]+$/, '');
        },
        async validateAnimationFile(file, filename) {
            const name = filename || file.name || '';
            if (!name.toLowerCase().endsWith('.mp4')) {
                throw new Error(`${name} 不是 mp4 格式`);
            }
            if (file.size > 50 * 1024 * 1024) {
                throw new Error(`${name} 超过 50MB，无法自动压缩`);
            }
        },
        beforeAnimationUpload(file) {
            return this.validateAnimationFile(file).then(() => file).catch(error => {
                ElMessage.error(error.message || '动图校验失败');
                return Promise.reject();
            });
        },
        clientBatchCategoryMap() {
            const result = {};
            this.category_list.forEach(category => {
                if (category.key) result[category.key] = category.id;
                const name = category.i18n_name?.ZH_HANS;
                if (name) result[name] = category.id;
            });
            return result;
        },
        newClientBatchSessionId() {
            const timestamp = Math.floor(Date.now() / 1000).toString(16).padStart(8, '0');
            let randomPart;
            if (globalThis.crypto?.randomUUID) {
                randomPart = globalThis.crypto.randomUUID();
            } else {
                const bytes = new Uint8Array(16);
                globalThis.crypto.getRandomValues(bytes);
                randomPart = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
            }
            return `ts${timestamp}-${randomPart}`;
        },
        throwIfClientBatchCancelled() {
            if (!this.batchProgress.cancelRequested) return;
            const error = new Error('本机批量任务已取消');
            error.batchUploadCancelled = true;
            throw error;
        },
        waitForClientBatchRetry(delay) {
            return new Promise((resolve, reject) => {
                const signal = this.clientBatchAbortController?.signal;
                const timer = setTimeout(() => {
                    signal?.removeEventListener('abort', handleAbort);
                    resolve();
                }, delay);
                const handleAbort = () => {
                    clearTimeout(timer);
                    const error = new Error('本机批量任务已取消');
                    error.batchUploadCancelled = true;
                    reject(error);
                };
                if (signal?.aborted) handleAbort();
                else signal?.addEventListener('abort', handleAbort, {once: true});
            });
        },
        async uploadClientBatchItem(item, prepared, animation, uploadKey) {
            let lastError;
            for (let attempt = 0; attempt < 5; attempt += 1) {
                if (this.batchProgress.cancelRequested) {
                    const error = new Error('本机批量任务已取消');
                    error.batchUploadCancelled = true;
                    throw error;
                }
                const form = new FormData();
                form.append('upload_key', uploadKey);
                form.append('image', prepared.image, prepared.image.name);
                form.append('thumbnail', prepared.thumbnail, prepared.thumbnail.name);
                if (animation) form.append('animation', animation, item.animationFilename);
                form.append('categories', JSON.stringify(item.categories));
                form.append('module', this.batchForm.module);
                form.append('needs_ai_tag', this.batchForm.needs_ai_tag ? 'true' : 'false');
                const testInfo = this.normalizedTestInfo(this.batchForm.test_info);
                if (testInfo) form.append('test_info', JSON.stringify(testInfo));
                try {
                    return await axios.post('/cms/v1/batch-image/client-item', form, {
                        signal: this.clientBatchAbortController?.signal,
                    });
                } catch (error) {
                    if (this.batchProgress.cancelRequested || error?.code === 'ERR_CANCELED') {
                        error.batchUploadCancelled = true;
                        throw error;
                    }
                    lastError = error;
                    const status = error?.response?.status;
                    if (status && status < 500) throw error;
                    if (attempt === 4) break;
                    const delay = Math.min(15000, 2000 * (2 ** attempt));
                    this.batchProgress.text = `上传 ${item.imageFilename} 失败，${delay / 1000} 秒后重试`;
                    await this.waitForClientBatchRetry(delay);
                }
            }
            if (lastError && typeof lastError === 'object') lastError.clientTransportFailure = true;
            throw lastError || new Error('素材上传失败');
        },
        async batchSubmitClient(file) {
            this.batchLoading = true;
            this.batchProgress.cancelRequested = false;
            this.batchProgress.clientMode = true;
            this.batchProgress.visible = true;
            this.batchProgress.status = undefined;
            this.batchProgress.text = '正在读取 ZIP 目录';
            this.batchProgress.errors = [];
            this.clientBatchAbortController = new AbortController();
            let archive;
            try {
                archive = await openClientBatchArchive(
                    file,
                    this.clientBatchCategoryMap(),
                    this.batchForm.categories,
                );
                this.throwIfClientBatchCancelled();
                if (archive.fallbackReason) {
                    ElMessage.info(`${archive.fallbackReason}，已自动切换到兼容流程`);
                    this.batchProgress.clientMode = false;
                    this.batchProgress.visible = false;
                    return false;
                }
                const config = {
                    categories: [...this.batchForm.categories],
                    module: this.batchForm.module,
                    needs_ai_tag: this.batchForm.needs_ai_tag,
                    force_resize: this.batchForm.force_resize,
                    test_info: this.normalizedTestInfo(this.batchForm.test_info),
                };
                const identity = clientBatchFileIdentity(file);
                const configSignature = clientBatchConfigSignature(config);
                let state = this.readClientBatchState();
                if (state && (state.identity !== identity || state.configSignature !== configSignature)) {
                    await ElMessageBox.confirm(
                        '存在另一批未完成的本机处理进度。继续将清除旧进度，但已成功导入的图片不会删除。',
                        '切换批量任务',
                        {type: 'warning', confirmButtonText: '清除并继续', cancelButtonText: '保留旧任务'},
                    );
                    this.clearClientBatchState();
                    state = null;
                }
                if (!state) {
                    state = {
                        identity,
                        filename: file.name,
                        sessionId: this.newClientBatchSessionId(),
                        total: archive.items.length,
                        completed: [],
                        config,
                        configSignature,
                    };
                }
                const completed = new Set((state.completed || []).map(Number));
                await ElMessageBox.confirm(
                    `浏览器将逐张处理并上传 ${archive.items.length} 张图片，已完成 ${completed.size} 张。任务运行时可以关闭弹窗继续操作页面。`,
                    '批量上传确认',
                    {type: 'info', confirmButtonText: '开始处理', cancelButtonText: '取消'},
                );
                this.writeClientBatchState(state);

                const errors = [];
                for (let index = 0; index < archive.items.length; index += 1) {
                    if (completed.has(index)) continue;
                    if (this.batchProgress.cancelRequested) {
                        const error = new Error('本机批量任务已取消');
                        error.batchUploadCancelled = true;
                        throw error;
                    }
                    const item = archive.items[index];
                    this.batchProgress.percent = Math.floor(completed.size * 100 / archive.items.length);
                    this.batchProgress.text = `本机正在处理 ${index + 1}/${archive.items.length}：${item.imageFilename}`;
                    try {
                        const source = await readClientBatchEntry(item.imageEntry, item.imageContentType);
                        this.throwIfClientBatchCancelled();
                        const prepared = await preprocessClientBatchImage(
                            source,
                            item.imageFilename,
                            this.batchForm.force_resize,
                            this.clientBatchAbortController?.signal,
                        );
                        this.throwIfClientBatchCancelled();
                        const animation = item.animationEntry
                            ? await readClientBatchEntry(item.animationEntry, 'video/mp4')
                            : null;
                        this.throwIfClientBatchCancelled();
                        await this.uploadClientBatchItem(
                            item, prepared, animation, `${state.sessionId}:${index}`);
                        completed.add(index);
                        state.completed = [...completed].sort((left, right) => left - right);
                        this.writeClientBatchState(state);
                    } catch (error) {
                        if (error.batchUploadCancelled || error.clientTransportFailure) throw error;
                        errors.push({
                            filename: item.imageFilename,
                            error_message: this.getErrorMessage(error),
                        });
                    }
                    this.batchProgress.success = completed.size;
                    this.batchProgress.errors = errors;
                }

                if (!errors.length) this.clearClientBatchState();
                this.batchProgress.percent = 100;
                this.batchProgress.status = errors.length ? 'warning' : 'success';
                this.batchProgress.text = errors.length
                    ? `本轮完成：成功 ${completed.size} 张，失败 ${errors.length} 张；重新选择原 ZIP 只重试失败项`
                    : `批量导入完成：成功 ${completed.size} 张`;
                this.batchProgress.clientMode = Boolean(errors.length);
                this.fileList = [];
                this.batchForm.file = null;
                this.dialogBatch_opened = false;
                if (errors.length) ElMessage.warning(this.batchProgress.text);
                else ElMessage.success(this.batchProgress.text);
                await this.reload();
                return true;
            } catch (error) {
                if (error === 'cancel' || error === 'close') {
                    const state = this.readClientBatchState();
                    if (!state) this.resetBatchProgress();
                    return true;
                }
                if (!error.batchUploadCancelled) {
                    this.batchProgress.status = 'exception';
                    this.batchProgress.text = `本机处理已暂停：${this.getErrorMessage(error)}；重新选择原 ZIP 可以继续`;
                    ElMessage.error(this.batchProgress.text);
                }
                return true;
            } finally {
                if (archive?.reader) await archive.reader.close();
                this.clientBatchAbortController = null;
                this.batchLoading = false;
            }
        },
        async confirmClientBatchCompatibilitySwitch() {
            const state = this.readClientBatchState();
            if (!state) return true;
            const completed = (state.completed || []).length;
            try {
                await ElMessageBox.confirm(
                    completed
                        ? `本机任务已成功导入 ${completed} 张。兼容流程会重新处理整个 ZIP，可能产生重复图片。确认清除断点并继续吗？`
                        : '存在未完成的本机任务。兼容流程不能沿用该断点，确认清除断点并继续吗？',
                    '切换到兼容流程',
                    {type: 'warning', confirmButtonText: '清除并继续', cancelButtonText: '保留原任务'},
                );
            } catch (_) {
                return false;
            }
            this.clearClientBatchState();
            return true;
        },
        async inspectBatchZip(file) {
            const zip = await JSZip.loadAsync(file);
            const groups = {};
            const imageExts = ['.jpg', '.jpeg', '.png', '.webp'];
            const entries = Object.values(zip.files).filter(entry => !entry.dir && !entry.name.startsWith('__MACOSX/'));
            for (const entry of entries) {
                const lowerName = entry.name.toLowerCase();
                const ext = lowerName.slice(lowerName.lastIndexOf('.'));
                const key = this.zipBaseName(entry.name);
                if (!imageExts.includes(ext) && ext !== '.mp4') {
                    continue;
                }
                if (!groups[key]) {
                    groups[key] = {images: [], animations: []};
                }
                if (ext === '.mp4') {
                    const blob = await entry.async('blob');
                    groups[key].animations.push(entry.name);
                    await this.validateAnimationFile(blob, entry.name);
                } else {
                    groups[key].images.push(entry.name);
                }
            }
            const withImage = Object.values(groups).filter(group => group.images.length > 0);
            const matched = withImage.filter(group => group.animations.length > 0).length;
            const missingVideo = withImage.filter(group => group.animations.length === 0).length;
            const onlyVideo = Object.values(groups).filter(group => group.images.length === 0 && group.animations.length > 0).length;
            return {matched, missingVideo, onlyVideo, entries: entries.map(entry => entry.name)};
        },
        async batchSubmit() {
            if (!this.batchForm.file || !this.batchForm.file.raw) {
                this.$message.error('请先选择压缩包文件')
                return
            }
            if (this.batchForm.file.raw.size <= 0) {
                this.$message.error('不能上传空压缩包')
                return
            }
            if (!this.batchForm.categories || this.batchForm.categories.length === 0) {
                this.$message.error('请选择分类')
                return
            }
            if (!this.batchForm.product || this.batchForm.product.length === 0) {
                this.$message.error('请选择所属产品')
                return
            }
            if (this.batchForm.client_preprocess) {
                const handled = await this.batchSubmitClient(this.batchForm.file.raw);
                if (handled) return;
            }
            if (!await this.confirmClientBatchCompatibilitySwitch()) {
                this.restoreBatchImageJob();
                return;
            }
            this.batchLoading = true;
            let inspection;
            try {
                inspection = await this.inspectBatchZip(this.batchForm.file.raw);
                const lines = [
                    `同名已匹配动图：${inspection.matched} 组`,
                    `缺少视频：${inspection.missingVideo} 张图片`,
                    `单独视频：${inspection.onlyVideo} 个（同批未匹配时将按文件名匹配已有图片 ID）`,
                    '非正方形、超过 720px、超过 20fps 或超过 2MB 的 MP4 将由服务端自动压缩',
                ];
                await ElMessageBox.confirm(lines.join('；'), '批量上传确认', {
                    confirmButtonText: '继续上传',
                    cancelButtonText: '取消',
                    type: 'warning',
                });
            } catch (error) {
                if (error !== 'cancel' && error !== 'close') {
                    ElMessage.error(error.message || '压缩包检查失败');
                }
                this.batchLoading = false;
                return;
            }
            this.resetBatchProgress();
            this.batchProgress.visible = true;
            this.batchUploadAbortController = new AbortController();
            try {
                const file = this.batchForm.file.raw;
                const chunkSize = 8 * 1024 * 1024;
                const totalChunks = Math.ceil(file.size / chunkSize);
                const initForm = new FormData();
                initForm.append('filename', file.name);
                initForm.append('total_chunks', totalChunks);
                initForm.append('file_size', file.size);
                initForm.append('module', this.batchForm.module);
                initForm.append('product', this.batchForm.product);
                initForm.append('categories', JSON.stringify(this.batchForm.categories));
                initForm.append('needs_ai_tag', this.batchForm.needs_ai_tag ? 'true' : 'false');
                initForm.append('force_resize', this.batchForm.force_resize ? 'true' : 'false');
                const testInfo = this.normalizedTestInfo(this.batchForm.test_info);
                if (testInfo) initForm.append('test_info', JSON.stringify(testInfo));
                initForm.append('zip_manifest', JSON.stringify(inspection.entries));
                const initRes = await axios.post('/cms/v1/batch-image/job', initForm);
                const job = initRes.data.data.job;
                this.updateBatchProgress(job);

                for (let index = 0; index < totalChunks; index += 1) {
                    const chunk = file.slice(index * chunkSize, Math.min(file.size, (index + 1) * chunkSize));
                    const chunkRes = await this.uploadBatchChunk(job.id, index, chunk, file.name);
                    this.updateBatchProgress(chunkRes.data.data.job);
                }

                this.fileList = [];
                this.batchForm.file = null;
                this.dialogBatch_opened = false;
                this.batchUploadAbortController = null;
                ElMessage.info('压缩包上传完成，后台正在导入图片');
                rememberAndRunBatchImageJob(job.id, getProduct().key);
                await this.pollBatchImageJob(job.id);
            } catch (err) {
                this.batchUploadAbortController = null;
                if (err.batchUploadCancelled || this.batchProgress.cancelRequested) {
                    this.batchLoading = false;
                    return;
                }
                this.batchLoading = false;
                this.batchProgress.status = 'exception';
                const detail = err.batchChunkErrorMessage || this.getErrorMessage(err);
                if (Number.isInteger(err.batchChunkIndex)) {
                    const filename = `压缩包第 ${err.batchChunkIndex + 1} 个分片`;
                    this.batchProgress.errors = [{filename, error_message: detail}];
                    this.batchProgress.text = `批量上传失败：${filename}。${detail}`;
                }
                ElMessage.error('批量上传失败: ' + detail);
            }
        },
        handleSuccess(res) {
            this.loading = false;
            this.form.resource = res.data.name
        },
        handleAnimationSuccess(res) {
            this.loading = false;
            this.form.animation = res.data.name
        },
        handleProgress() {
            this.loading = true;
        },
        beforeUpload(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = e => {
                    const image = new Image();
                    image.src = e.target.result;
                    image.onload = _ => {
                        if (image.height === 2048 && image.width === 2048) {
                            resolve();
                        } else {
                            reject();
                        }
                    }
                }
            }).then(_ => {
                return file;
            }, _ => {
                ElMessage.error('图片尺寸必须是2048 * 2048');
                return Promise.reject()
            })
        },
        removeTag(category, tag) {
            this.form[category].splice(this.form[category].indexOf(tag), 1);
        },
        addTag(value, category) {
            this.form[category].push(value);
        },
        removeBatchTag(category, tag) {
            this.batchTagForm[category].splice(this.batchTagForm[category].indexOf(tag), 1);
        },
        addBatchTag(value, category) {
            if (!this.batchTagForm[category].includes(value)) {
                this.batchTagForm[category].push(value);
            }
        },
        
        // Toggle tag selection in delete mode
        toggleBatchTag(category, tag) {
            const index = this.batchTagForm[category].indexOf(tag);
            if (index > -1) {
                this.batchTagForm[category].splice(index, 1);
            } else {
                this.batchTagForm[category].push(tag);
            }
        },

        collectionReferenceText(ref) {
            const stateLabel = {
                online: '线上',
                scheduled: '待上线',
                inactive: '停用',
            }[ref.state] || '占用';
            const typeLabel = ref.type_label || {
                collection: '普通合集',
                magic: '魔法合集',
                story: '故事合集',
            }[ref.type] || '合集';
            return `${stateLabel}${typeLabel}${ref.name ? ` · ${ref.name}` : ''}`;
        },
        collectionRefsText(row) {
            const refs = row.collection_refs || [];
            return refs.length
                ? refs.map(ref => this.collectionReferenceText(ref)).join('、')
                : '所属合集';
        },
        isImageDeletable(row) {
            // 合集占用不可删；跨产品图可删（仅解绑当前产品）。
            return row.deletable !== false && row.collection_assigned !== true;
        },
        deleteProtectionText(row) {
            return this.isImageDeletable(row)
                ? ''
                : (row.delete_block_reason || `${this.collectionRefsText(row)}正在使用该图片，请先从对应合集移除`);
        },
        remove(row) {
            if (!this.canDeleteGallery) {
                ElMessage.error('无图库删除权限');
                return;
            }
            if (!this.isImageDeletable(row)) {
                ElMessage.warning(this.deleteProtectionText(row));
                return;
            }
            ElMessageBox.confirm(this.deleteConfirmText(row), '删除图片', {
                cancelButtonText: '取消',
                confirmButtonText: '确定',
                type: 'warning',
            }).then(_ => {
                this.loading = true;
                axios.delete(`/cms/v1/image/${row.id}`).then(res => {
                    this.data.splice(this.data.indexOf(row), 1);
                    this.total = Math.max(0, this.total - 1);
                    this.selectedItems.delete(row.id);
                    this.selectedImageMap.delete(row.id);
                    this.idList = this.idList.filter(id => id !== row.id);
                    ElMessage.success(this.deleteResultText(res.data.data || {}));
                }).catch(err => {
                    ElMessage.error('删除失败: ' + this.getErrorMessage(err));
                }).finally(() => {
                    this.loading = false;
                });
            }).catch(() => {});
        },
        batchDelete(){
            if (!this.canDeleteGallery) {
                ElMessage.error('无图库删除权限');
                return;
            }
            const selected = Array.from(this.selectedImageMap.values());
            const blocked = selected.filter(row => !this.isImageDeletable(row));
            if (blocked.length) {
                const details = blocked.map(row => `${row.id}（${this.deleteProtectionText(row)}）`).join('、');
                ElMessage.error(`选中项中有 ${blocked.length} 张图片当前不可删除，整批未执行：${details}`);
                return;
            }
            const shared = selected.filter(row => this.sharedProductKeys(row).length > 1);
            const deleteCount = selected.length - shared.length;
            const details = [];
            if (shared.length) {
                details.push(`${shared.length} 张跨产品图片仅从当前产品移除，不会删除图片资源或影响其它产品`);
            }
            if (deleteCount) {
                details.push(`${deleteCount} 张当前产品独占图片将立即彻底删除，不可恢复`);
            }
            ElMessageBox.confirm(`确定处理选中的 ${selected.length} 张图片吗？${details.join('；')}。`, '批量删除图片', {
                cancelButtonText: '取消',
                confirmButtonText: '确定',
                type: 'warning',
            }).then(_ => {
                this.loading = true;
                axios.post(`/cms/v1/batch-delete`,{ids: this.idList}).then(res => {
                    const results = res.data.data || [];
                    const detachedCount = results.filter(item => item.delete_action === 'detached_from_product').length;
                    const deletedCount = results.filter(item => item.delete_action === 'deleted').length;
                    this.clearAllSelection();
                    const summary = [];
                    if (detachedCount) summary.push(`${detachedCount} 张仅从当前产品移除`);
                    if (deletedCount) summary.push(`${deletedCount} 张已彻底删除`);
                    ElMessage.success(summary.length ? summary.join('，') : '批量删除成功');
                    this.reload();
                }).catch(err => {
                    ElMessage.error('批量删除失败: ' + this.getErrorMessage(err));
                }).finally(() => {
                    this.loading = false;
                });
            }).catch(() => {});
        },
        openBatchTagDialog() {
            this.batchTagDialog = true;
            // Reset form when opening dialog
            this.batchTagForm.major_tags = [];
            this.batchTagForm.minor_tags = [];
            this.batchTagForm.assistant_tags = [];
            
            // 初始化所有产品的模块配置
            const modulesConfig = {};
            getProductList().forEach(product => {
                modulesConfig[product.key] = null;
            });
            this.batchTagForm.modules = modulesConfig;
            
            // If in delete mode, calculate common tags from selected items
            if (this.tagMode === 'delete' && this.idList.length > 0) {
                this.calculateCommonTags();
            }
        },
        
        // Calculate common tags from selected items
        calculateCommonTags() {
            // Get selected items from current data
            const selectedItems = this.data.filter(item => this.idList.includes(item.id));
            
            if (selectedItems.length === 0) return;
            
            // Initialize with tags from first selected item
            let commonMajorTags = new Set(selectedItems[0].major_tags || []);
            let commonMinorTags = new Set(selectedItems[0].minor_tags || []);
            let commonAssistantTags = new Set(selectedItems[0].assistant_tags || []);
            let commonCategories = new Set(selectedItems[0].categories || []);
            let commonProduct = new Set(selectedItems[0].product || []);
            
            // Find intersection with other selected items
            for (let i = 1; i < selectedItems.length; i++) {
                const item = selectedItems[i];
                commonMajorTags = new Set([...commonMajorTags].filter(tag => item.major_tags?.includes(tag)));
                commonMinorTags = new Set([...commonMinorTags].filter(tag => item.minor_tags?.includes(tag)));
                commonAssistantTags = new Set([...commonAssistantTags].filter(tag => item.assistant_tags?.includes(tag)));
                commonCategories = new Set([...commonCategories].filter(cat => item.categories?.includes(cat)));
                commonProduct = new Set([...commonProduct].filter(prod => item.product?.includes(prod)));
            }
            
            // Update common tag lists for display
            this.commonTags = {
                major_tags: Array.from(commonMajorTags),
                minor_tags: Array.from(commonMinorTags),
                assistant_tags: Array.from(commonAssistantTags),
                categories: Array.from(commonCategories),
                product: Array.from(commonProduct)
            };
        },
        batchTagReset() {
            this.batchTagDialog = false;
            // Clear form data
            this.batchTagForm.major_tags = [];
            this.batchTagForm.minor_tags = [];
            this.batchTagForm.assistant_tags = [];
            this.batchTagForm.categories = [];
            this.batchTagForm.product = [];
            // Clear common tags
            this.commonTags.major_tags = [];
            this.commonTags.minor_tags = [];
            this.commonTags.assistant_tags = [];
            this.commonTags.categories = [];
            this.commonTags.product = [];
            if (this.$refs.batchTagForm) {
                this.$refs.batchTagForm.resetFields();
            }
        },
        clearAllSelection() {
            // Clear all selected items
            this.selectedItems.clear();
            this.selectedImageMap.clear();
            this.idList = [];
            // Clear table selection
            if (this.$refs.table) {
                this.$refs.table.clearSelection();
            }
        },
        selectedImages() {
            return Array.from(this.selectedImageMap.values());
        },
        async downloadSelectedImages() {
            const selectedImages = this.selectedImages().filter(image => image.resource);
            if (!selectedImages.length) {
                ElMessage.warning('选中图片中没有可下载的原图');
                return;
            }

            this.downloadingImages = true;
            try {
                const result = await downloadResourcesAsZip(
                    selectedImages,
                    `全局图库原图-${Date.now()}.zip`,
                    {timeout: 45000},
                );
                if (result.failureCount) {
                    ElMessage.warning(`原图下载完成，但有 ${result.failureCount} 张失败`);
                } else {
                    ElMessage.success(`原图下载成功：${result.successCount} 张`);
                }
            } catch (err) {
                console.error('下载全局图库原图失败:', err);
                ElMessage.error('原图下载失败');
            } finally {
                this.downloadingImages = false;
            }
        },
        batchAuditSelected() {
            if (!this.idList.length) {
                ElMessage.warning('请先选择图片');
                return;
            }
            ElMessageBox.confirm(`确定要将选中的 ${this.idList.length} 张图片状态改为「通过」吗？`, '批量通过', {
                cancelButtonText: '取消',
                confirmButtonText: '确定',
                type: 'warning',
            }).then(() => {
                this.loading = true;
                axios.post(`/cms/v1/batch-tag`, {
                    ids: this.idList,
                    mode: 'add',
                    status: 'AUDITED',
                }).then(res => {
                    const updatedImages = res.data.data || [];
                    updatedImages.forEach(updatedImg => {
                        const index = this.data.findIndex(item => item.id === updatedImg.id);
                        if (index >= 0) {
                            this.data.splice(index, 1, updatedImg);
                        }
                    });
                    ElMessage.success(`已将 ${updatedImages.length} 张图片改为通过`);
                }).catch(err => {
                    ElMessage.error('批量通过失败: ' + this.getErrorMessage(err));
                }).finally(() => {
                    this.loading = false;
                });
            }).catch(() => {});
        },
        openBatchTestDialog() {
            if (!this.idList.length) {
                ElMessage.warning('请先选择图片');
                return;
            }
            const selected = this.selectedImages();
            const first = selected.find(image => image.test_info?.direction)?.test_info;
            this.batchTestForm = {
                goal: first?.goal || '',
                direction: first?.direction || '',
                hypothesis: first?.hypothesis || '',
                duration_days: first?.duration_days || 7,
                status: first?.status || 'WAITING',
            };
            this.batchTestDialog = true;
        },
        submitBatchTest() {
            this.$refs.batchTestForm.validate(valid => {
                if (!valid) return;
                if (!this.normalizedTestInfo(this.batchTestForm)) {
                    ElMessage.warning('请选择测试目标和推荐方向');
                    return;
                }
                this.loading = true;
                axios.post('/cms/v1/batch-tag', {
                    ids: this.idList,
                    mode: 'add',
                    test_info: this.normalizedTestInfo(this.batchTestForm),
                }).then(res => {
                    const updatedImages = res.data.data || [];
                    updatedImages.forEach(updatedImg => {
                        const index = this.data.findIndex(item => item.id === updatedImg.id);
                        if (index >= 0) this.data.splice(index, 1, updatedImg);
                    });
                    this.batchTestDialog = false;
                    ElMessage.success(`已标记 ${updatedImages.length} 张测试图，批次由系统自动生成`);
                    this.clearAllSelection();
                }).catch(err => {
                    ElMessage.error('标记测试方向失败: ' + this.getErrorMessage(err));
                }).finally(() => {
                    this.loading = false;
                });
            });
        },
        batchTagSubmit() {
            this.$refs.batchTagForm.validate(valid => {
                if (valid) {
                    this.loading = true;
                    const params = {
                        ids: this.idList,
                        mode: this.tagMode,
                        major_tags: this.batchTagForm.major_tags,
                        minor_tags: this.batchTagForm.minor_tags,
                        assistant_tags: this.batchTagForm.assistant_tags,
                        categories: this.batchTagForm.categories,
                        product: this.batchTagForm.product
                    };
                    
                    // 仅追加模式且有模块修改时，添加模块数据
                    if (this.tagMode === 'add' && this.hasBatchModuleEdit()) {
                        params.modules = this.batchTagForm.modules;
                    }
                    
                    // 调用批量操作接口
                    axios.post(`/cms/v1/batch-tag`, params).then(res => {
                        // 直接使用后端返回的最新数据更新本地列表
                        const updatedImages = res.data.data || [];
                        updatedImages.forEach(updatedImg => {
                            const index = this.data.findIndex(item => item.id === updatedImg.id);
                            if (index >= 0) {
                                this.data.splice(index, 1, updatedImg);
                            }
                        });
                        
                        this.batchTagReset();
                        ElMessage.success(this.tagMode === 'add' ? '批量操作成功' : '批量删除成功');
                        this.loading = false;
                    }).catch(err => {
                        ElMessage.error((this.tagMode === 'add' ? '批量操作失败: ' : '批量删除失败: ') + this.getErrorMessage(err));
                        this.loading = false;
                    });
                }
            });
        },
        handleSelectionChange(val) {
            // Update selectedItems set based on current page selection
            const currentPageIds = new Set(val.map(item => item.id));
            const pageItemIds = new Set(this.data.map(item => item.id));
            
            // Remove items from selectedItems that are on this page but not selected
            pageItemIds.forEach(id => {
                if (!currentPageIds.has(id)) {
                    this.selectedItems.delete(id);
                    this.selectedImageMap.delete(id);
                }
            });
            
            // Add items from current selection to selectedItems
            val.forEach(item => {
                this.selectedItems.add(item.id);
                this.selectedImageMap.set(item.id, item);
            });
            
            this.idList = Array.from(this.selectedItems);
        },
        // Method to handle row selection status when data changes (page switch)
        rowKey(row) {
            return row.id;
        },
        // Method to determine if a row should be selected
        reserveSelection(row) {
            return this.selectedItems.has(row.id);
        },
        // 条件编辑相关方法
        openConditionEditDialog() {
            // 复制当前查询条件到条件编辑查询
            this.conditionQuery = {
                id: this.query.id,
                online: this.query.online,
                category_ids: [...(this.query.category_ids || [])],
                products: [...(this.query.products || [])],
                status: this.query.status,
                source: this.query.source,
                module: this.query.module,
                major_tags: [...(this.query.major_tags || [])],
                minor_tags: [...(this.query.minor_tags || [])],
                assistant_tags: [...(this.query.assistant_tags || [])],
                start: this.query.start,
                end: this.query.end,
                unauthorized: this.query.unauthorized,
                video: this.query.video,
                is_animated: this.query.is_animated,
            };
            // 重置操作表单，为所有产品初始化模块配置
            const modulesConfig = {};
            getProductList().forEach(product => {
                modulesConfig[product.key] = null;
            });
            
            this.conditionEditForm = {
                product: [],
                productMode: 'add',
                categories: [],
                categoriesMode: 'add',
                major_tags: [],
                majorTagsMode: 'add',
                minor_tags: [],
                minorTagsMode: 'add',
                assistant_tags: [],
                assistantTagsMode: 'add',
                include_country: [],
                includeCountryMode: 'add',
                exclude_country: [],
                excludeCountryMode: 'add',
                status: null,
                cost: null,
                online_date: null,
                platform: null,
                source: null,
                module: null,
                modules: modulesConfig,
                unauthorized: null
            };
            this.conditionEditDialog = true;
        },
        conditionEditReset() {
            this.conditionEditDialog = false;
            this.conditionEditForm.modules = {};
            if (this.$refs.conditionEditForm) {
                this.$refs.conditionEditForm.resetFields();
            }
        },
        hasModuleEdit() {
            return this.conditionEditForm.modules &&
                   Object.keys(this.conditionEditForm.modules).some(key => this.conditionEditForm.modules[key] !== null);
        },
        hasBatchModuleEdit() {
            return this.batchTagForm.modules &&
                   Object.keys(this.batchTagForm.modules).some(key => this.batchTagForm.modules[key] !== null);
        },
        addConditionTag(value, category) {
            if (!this.conditionEditForm[category].includes(value)) {
                this.conditionEditForm[category].push(value);
            }
        },
        removeConditionTag(category, tag) {
            this.conditionEditForm[category].splice(this.conditionEditForm[category].indexOf(tag), 1);
        },
        conditionEditSubmit() {
            // 检查是否有至少一个操作
            const hasOperation = 
                (this.conditionEditForm.product && this.conditionEditForm.product.length > 0) ||
                (this.conditionEditForm.categories && this.conditionEditForm.categories.length > 0) ||
                (this.conditionEditForm.major_tags && this.conditionEditForm.major_tags.length > 0) ||
                (this.conditionEditForm.minor_tags && this.conditionEditForm.minor_tags.length > 0) ||
                (this.conditionEditForm.assistant_tags && this.conditionEditForm.assistant_tags.length > 0) ||
                this.conditionEditForm.status !== null ||
                this.conditionEditForm.cost !== null ||
                this.conditionEditForm.online_date !== null ||
                this.conditionEditForm.platform !== null ||
                (this.conditionEditForm.source !== null && this.conditionEditForm.source !== '') ||
                this.conditionEditForm.module !== null ||
                this.hasModuleEdit() ||
                (this.conditionEditForm.include_country && this.conditionEditForm.include_country.length > 0) ||
                (this.conditionEditForm.exclude_country && this.conditionEditForm.exclude_country.length > 0) ||
                this.conditionEditForm.unauthorized !== null;
            
            if (!hasOperation) {
                ElMessage.warning('请至少选择一个操作');
                return;
            }
            
            this.loading = true;
            // 构建查询条件参数
                    const queryParams = {...this.conditionQuery};
                    if (queryParams.category_ids && queryParams.category_ids.length > 0) {
                        queryParams.category_ids = queryParams.category_ids.join(',');
                    } else {
                        delete queryParams.category_ids;
                    }
                    if (queryParams.products && queryParams.products.length > 0) {
                        queryParams.products = queryParams.products.join(',');
                    } else {
                        delete queryParams.products;
                    }
                    if (queryParams.major_tags && queryParams.major_tags.length > 0) {
                        queryParams.major_tags = queryParams.major_tags.join(',');
                    } else {
                        delete queryParams.major_tags;
                    }
                    if (queryParams.minor_tags && queryParams.minor_tags.length > 0) {
                        queryParams.minor_tags = queryParams.minor_tags.join(',');
                    } else {
                        delete queryParams.minor_tags;
                    }
                    if (queryParams.assistant_tags && queryParams.assistant_tags.length > 0) {
                        queryParams.assistant_tags = queryParams.assistant_tags.join(',');
                    } else {
                        delete queryParams.assistant_tags;
                    }
                    
                    // 构建更新操作参数
                    const updateParams = {
                        query: queryParams,
                        operations: {}
                    };
                    
                    // 批量操作：产品、分类、标签
                    if (this.conditionEditForm.product && this.conditionEditForm.product.length > 0) {
                        updateParams.operations.product = {
                            mode: this.conditionEditForm.productMode,
                            values: this.conditionEditForm.product
                        };
                    }
                    if (this.conditionEditForm.categories && this.conditionEditForm.categories.length > 0) {
                        updateParams.operations.categories = {
                            mode: this.conditionEditForm.categoriesMode,
                            values: this.conditionEditForm.categories
                        };
                    }
                    if (this.conditionEditForm.major_tags && this.conditionEditForm.major_tags.length > 0) {
                        updateParams.operations.major_tags = {
                            mode: this.conditionEditForm.majorTagsMode,
                            values: this.conditionEditForm.major_tags
                        };
                    }
                    if (this.conditionEditForm.minor_tags && this.conditionEditForm.minor_tags.length > 0) {
                        updateParams.operations.minor_tags = {
                            mode: this.conditionEditForm.minorTagsMode,
                            values: this.conditionEditForm.minor_tags
                        };
                    }
                    if (this.conditionEditForm.assistant_tags && this.conditionEditForm.assistant_tags.length > 0) {
                        updateParams.operations.assistant_tags = {
                            mode: this.conditionEditForm.assistantTagsMode,
                            values: this.conditionEditForm.assistant_tags
                        };
                    }
                    
                    // 其他操作
                    if (this.conditionEditForm.status !== null) {
                        updateParams.operations.status = this.conditionEditForm.status;
                    }
                    if (this.conditionEditForm.cost !== null) {
                        updateParams.operations.cost = this.conditionEditForm.cost;
                    }
                    if (this.conditionEditForm.online_date !== null) {
                        updateParams.operations.online_date = this.conditionEditForm.online_date;
                    }
                    if (this.conditionEditForm.platform !== null) {
                        updateParams.operations.platform = this.conditionEditForm.platform;
                    }
                    if (this.conditionEditForm.source !== null && this.conditionEditForm.source !== '') {
                        updateParams.operations.source = this.conditionEditForm.source;
                    }
                    if (this.hasModuleEdit()) {
                        updateParams.operations.modules = this.conditionEditForm.modules;
                    }
                    if (this.conditionEditForm.include_country && this.conditionEditForm.include_country.length > 0) {
                        updateParams.operations.include_country = {
                            mode: this.conditionEditForm.includeCountryMode,
                            values: this.conditionEditForm.include_country
                        };
                    }
                    if (this.conditionEditForm.exclude_country && this.conditionEditForm.exclude_country.length > 0) {
                        updateParams.operations.exclude_country = {
                            mode: this.conditionEditForm.excludeCountryMode,
                            values: this.conditionEditForm.exclude_country
                        };
                    }
                    if (this.conditionEditForm.unauthorized !== null) {
                        updateParams.operations.unauthorized = this.conditionEditForm.unauthorized;
                    }
                    
                    // 调用条件批量更新接口
                    axios.post(`/cms/v1/condition-update`, updateParams).then(res => {
                        ElMessage.success('条件批量更新成功');
                        this.conditionEditReset();
                        return this.init();
                    }).catch(err => {
                        ElMessage.error('条件批量更新失败: ' + (err.response?.data?.status?.msg || err.message));
                    }).finally(() => {
                        this.loading = false;
                    });
        }
    },
        beforeUnmount() {
            window.removeEventListener('batch-image-job-update', this.handleBatchImageJobUpdate);
            window.removeEventListener('beforeunload', this.handleBeforeUnload);
            if (this.batchProgress.timer) {
                clearTimeout(this.batchProgress.timer);
            }
            if (this.dimensionRepair.timer) {
                clearTimeout(this.dimensionRepair.timer);
            }
        },
        mounted() {
            window.addEventListener('batch-image-job-update', this.handleBatchImageJobUpdate);
            window.addEventListener('beforeunload', this.handleBeforeUnload);
            this.restoreDimensionRepairJob();
            this.loading = true;
            axios.all([
            axios.get(`/cms/v1/category`).then(res => {
                this.category_list = sortCmsCategoryOptions(
                    res.data.data.categoryList.filter(c => !['ALL', 'COLLECTION'].includes(c.key))
                );
                this.category_list.forEach(c => {
                    this.category_map[c.id] = c.i18n_name.ZH_HANS;
                });
            }),
            axios.get('/cms/v1/tag/major').then(res => {
                this.major_list = res.data.data.tagList;
                this.df(this.major_map, this.major_list);
            }),
            axios.get('/cms/v1/tag/minor').then(res => {
                this.minor_list = res.data.data.tagList;
                this.df(this.minor_map, this.minor_list);
            }),
            axios.get('/cms/v1/tag/assistant').then(res => {
                this.assistant_list = res.data.data.tagList;
                this.df(this.assistant_map, this.assistant_list);
            }),
            axios.get('/cms/v1/source').then(res => {
                this.source_list = [];
                res.data.data.sourceList.forEach(s => {
                    if (s && !this.source_list.includes(s)) {
                        this.source_list.push(s);
                    }
                });
            }),
        ]).then(_ => {
            return this.init();
        }).catch(err => {
            ElMessage.error('初始化页面失败: ' + this.getErrorMessage(err));
        }).finally(() => {
            this.loading = false;
            this.restoreBatchImageJob();
        })
    },
}
</script>

<style scoped>

.el-select {
  width: 200px;
}

/* 条件编辑弹窗样式 */
:deep(.condition-edit-dialog .el-dialog__body) {
  padding: 20px;
  max-height: 70vh;
  overflow: hidden;
}

:deep(.condition-edit-dialog .el-dialog__wrapper) {
  overflow: hidden;
}

:deep(.condition-edit-dialog) {
  overflow: hidden;
}

.condition-edit-content {
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
}

.condition-edit-content::-webkit-scrollbar {
  width: 0;
  background: transparent;
}

.condition-edit-content {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

:deep(.condition-edit-dialog) {
  overflow: hidden;
}

.filter-container {
  display: flex;
  flex-wrap: wrap;
  gap: 3px 3px;
  max-height: calc(42px * 3 + 12px * 2);
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 4px;
}

.filter-container::-webkit-scrollbar {
  height: 0;
  background: transparent;
}

.filter-container::-webkit-scrollbar-thumb {
  background: transparent;
}

.filter-container {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.filter-container .el-select {
  margin: 0;
}

.filter-container .el-cascader {
  margin: 0;
}

.filter-container .el-input {
  margin: 0;
}

.filter-container .el-button {
  margin: 0;
}
:deep(.el-cascader__tags) {
    flex-wrap: nowrap;
}


</style>
